


// import { useEffect, useState } from "react";
// import axios from "axios";
// import { useLocation, useNavigate } from "react-router-dom";
// import {
//   Box,
//   Button,
//   Card,
//   CardContent,
//   CircularProgress,
//   Container,
//   Grid,
//   IconButton,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TextField,
//   Typography,
//   Chip,
//   useTheme,
//   useMediaQuery,
//   Avatar,
//   Divider,
//   Snackbar,
//   Alert,
//   InputAdornment,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Drawer,
//   MenuItem,
//   FormControl,
//   Select,
// } from "@mui/material";
// import {
//   DateRange as DateRangeIcon,
//   AccessTime as TimeIcon,
//   Person as PersonIcon,
//   Add as AddIcon,
//   CheckCircle as CheckCircleIcon,
//   Pending as PendingIcon,
//   Search as SearchIcon,
//   Refresh as RefreshIcon,
//   Close as CloseIcon,
//   Print as PrintIcon,
//   Usb as UsbIcon,
//   CloudUpload as CloudUploadIcon,
//   AutoAwesome as AutoAwesomeIcon,
//   Download as DownloadIcon,
// } from "@mui/icons-material";
// import auralogo from "../assets/AuraLogo.ico";

// // Enhanced Thermal Print Component using Browser Print with ESC/POS Simulation
// const ThermalPrintDialog = ({ 
//   open, 
//   onClose, 
//   appointment 
// }) => {
//   const [isPrinting, setIsPrinting] = useState(false);
//   const [printMethod, setPrintMethod] = useState('browser');
//   const [status, setStatus] = useState('');

//   const formatTime = (timeString) => {
//     return new Date(`1970-01-01T${timeString}`).toLocaleTimeString("en-LK", {
//       hour: "numeric",
//       minute: "numeric",
//       hour12: true,
//     });
//   };

//   // Generate ESC/POS commands for thermal printers
//   const generateEscPosCommands = () => {
//     const currentDate = new Date().toLocaleDateString('en-LK');
//     const currentTime = new Date().toLocaleTimeString('en-LK', { 
//       hour: '2-digit', 
//       minute: '2-digit',
//       hour12: false 
//     });

//     // ESC/POS commands
//     const commands = [
//       '\x1B\x40', // Initialize printer
//       '\x1B\x61\x01', // Center alignment
//       '\x1B\x21\x30', // Double height and width
//       'AURA MEDITATION CENTER\n',
//       '\x1B\x21\x00', // Normal text
//       '\x1B\x61\x00', // Left alignment
//       '================================\n',
//       '\x1B\x61\x01', // Center alignment
//       '\x1B\x45\x01', // Bold on
//       'APPOINTMENT CONFIRMATION\n',
//       '\x1B\x45\x00', // Bold off
//       '================================\n',
//       '\x1B\x61\x00', // Left alignment
//       `Patient: ${appointment?.MAD_FULL_NAME || 'N/A'}\n`,
//       // `Time: ${formatTime(appointment?.MAD_ALLOCATED_TIME)}\n`,
//       // `Contact: ${appointment?.MAD_CONTACT || 'N/A'}\n`,
//       // `Date: ${currentDate}\n`,
//       '\n',
//       '================================\n',
//       '\x1B\x61\x01', // Center alignment
//       '\x1B\x21\x30', // Double height and width
//       'CHANNEL NUMBER\n',
//       `${appointment?.MAD_PATIENT_NO || 'N/A'}\n`,
//       '\x1B\x21\x00', // Normal text
//       '\n',
//       '================================\n',
//       '\x1B\x45\x01', // Bold on
//       'ARRIVE 30 MINUTES EARLY\n',
//       '\x1B\x45\x00', // Bold off
//       '\n',
//       // 'THANK YOU!\n',
//       // 'Aura Meditation Center\n',
//       // '\n',
//       // '********************************\n',
//       // `Generated: ${currentDate} ${currentTime}\n`,
//       '\n\n\n\n',
//       '\x1D\x56\x41\x03' // Cut paper
//     ];

//     return commands.join('');
//   };

//   // Method 1: Browser Print with Thermal Printer CSS
//   const handleBrowserPrint = () => {
//     setIsPrinting(true);
//     setStatus('Preparing print...');

//     const printContent = `
//       <!DOCTYPE html>
//       <html>
//       <head>
//         <title>Appointment Receipt - Aura Meditation Center</title>
//        <style>
//   @media print {
//     @page {
//       margin: 0;
//       size: 80mm 150mm;
//       margin: 2mm;
//     }
    
//     body {
//       margin: 0;
//       padding: 2mm;
//       font-family: 'Courier New', monospace;
//       font-size: 10px;
//       line-height: 1.2;
//       width: 76mm;
//       background: white;
//       color: black;
//       -webkit-print-color-adjust: exact;
//       print-color-adjust: exact;
//     }
    
//     .receipt {
//       width: 76mm;
//       margin: 0 auto;
//     }
    
//     .header {
//       text-align: center;
//       margin-bottom: 3px;
//     }
    
//     .center {
//       text-align: center;
//     }
    
//     .bold {
//       font-weight: bold;
//     }
    
//     .large {
//       font-size: 14px;
//       font-weight: bold;
//     }
    
//     .x-large {
//       font-size: 16px;
//       font-weight: bold;
//     }
    
//     .divider {
//       border-bottom: 2px solid #000; /* Thicker and darker */
//       margin: 3px 0;
//       height: 2px;
//     }
    
//     .double-divider {
//       border-bottom: 3px solid #000; /* Thicker and darker */
//       margin: 4px 0;
//       height: 3px;
//     }
    
//     .channel-number {
//       text-align: center;
//       margin: 8px 0;
//       padding: 5px;
//       border: 3px solid #000; /* Thicker border */
//       background: #f0f0f0; /* Light gray background */
//     }
    
//     .important {
//       background: #000 !important;
//       color: #fff !important;
//       padding: 4px;
//       text-align: center;
//       margin: 6px 0;
//       -webkit-print-color-adjust: exact;
//       print-color-adjust: exact;
//       border: 1px solid #000; /* Added border */
//     }
    
//     .footer {
//       text-align: center;
//       margin-top: 10px;
//       font-weight: bold;
//     }
    
//     .logo {
//       text-align: center;
//       margin-bottom: 5px;
//     }
    
//     .logo-img {
//       max-width: 35mm;
//       height: auto;
//       filter: grayscale(100%) contrast(300%) brightness(40%) saturate(0%); /* Much darker */
//     }
    
//     .text-left {
//       text-align: left;
//     }
    
//     .text-right {
//       text-align: right;
//     }
    
//     .row {
//       display: flex;
//       justify-content: space-between;
//       margin: 2px 0;
//       border-bottom: 1px solid #333; /* Added subtle separator */
//       padding-bottom: 1px;
//     }

//     /* Additional darkening styles */
//     .header .x-large {
//       text-shadow: 0.5px 0.5px 0.5px #000; /* Subtle text shadow */
//     }
    
//     .channel-number .x-large {
//       text-shadow: 0.5px 0.5px 0.5px #000; /* Subtle text shadow */
//     }
    
//     .receipt {
//       box-shadow: 0 0 0 1px #000; /* Outer border */
//     }
//   }
  
//   /* Hide everything when printing */
//   @media screen {
//     body {
//       background: #f5f5f5;
//       padding: 20px;
//     }
//     .receipt {
//       border: 2px dashed #666; /* Darker dashed border for screen */
//       background: white;
//       padding: 10px;
//     }
//   }
// </style>
//       </head>
//       <body>
//         <div class="receipt">
//           <div class="logo">
//             <img src="${auralogo}" alt="Aura Meditation Center" class="logo-img">
//           </div>
          
//           <div class="header">
//             <div class="x-large">AURA MEDITATION CENTER</div>
//             <div class="double-divider"></div>
//             <div class="large">APPOINTMENT CONFIRMATION</div>
//             <div class="double-divider"></div>
//           </div>
          
//           <div class="text-left">
//             <div class="row">
//               <span class="bold">Patient:</span>
//               <span>${appointment?.MAD_FULL_NAME || 'N/A'}</span>
//             </div>
           
//           </div>
          
//           <div class="divider"></div>
          
//           <div class="channel-number">
//             <div class="x-large">CHANNEL NUMBER</div>
//             <div class="x-large">${appointment?.MAD_PATIENT_NO || 'N/A'}</div>
//           </div>
          
//           <div class="divider"></div>
          
//           <div class="important">
//             ARRIVE 30 MINUTES EARLY
//           </div>
          
//           <div class="footer">
//             <div class="bold">THANK YOU!</div>
//             <div class="bold">Aura Meditation Center</div>
//           </div>
          
//           <div class="divider"></div>
          
//           <div class="center">
//             <small>Generated: ${new Date().toLocaleString('en-LK')}</small>
//           </div>
//         </div>
        
//         <script>
//           // Auto-print and close
//           window.onload = function() {
//             setTimeout(function() {
//               window.print();
//               setTimeout(function() {
//                 window.close();
//               }, 500);
//             }, 500);
//           };
          
//           // Fallback for print issues
//           setTimeout(function() {
//             if (!document.hidden) {
//               window.print();
//               setTimeout(function() {
//                 window.close();
//               }, 500);
//             }
//           }, 3000);
//         </script>
//       </body>
//       </html>
//     `;

//     const printWindow = window.open('', '_blank', 'width=400,height=600');
//     if (printWindow) {
//       printWindow.document.write(printContent);
//       printWindow.document.close();
//       setStatus('Print dialog opened');
//     } else {
//       setStatus('Failed to open print window. Please allow popups.');
//     }
    
//     setTimeout(() => {
//       setIsPrinting(false);
//       onClose();
//     }, 2000);
//   };

//   // Method 2: Download ESC/POS file for manual transfer
//   const handleDownloadEscPos = () => {
//     setIsPrinting(true);
//     setStatus('Generating ESC/POS file...');
    
//     try {
//       const escPosData = generateEscPosCommands();
      
//       // Create a blob and download link
//       const blob = new Blob([escPosData], { type: 'application/octet-stream' });
//       const url = URL.createObjectURL(blob);
//       const a = document.createElement('a');
//       a.href = url;
//       a.download = `appointment-${appointment?.MAD_PATIENT_NO || 'receipt'}.txt`;
//       document.body.appendChild(a);
//       a.click();
//       document.body.removeChild(a);
//       URL.revokeObjectURL(url);
      
//       setStatus('ESC/POS file downloaded. Transfer to printer manually.');
//       setTimeout(() => {
//         setIsPrinting(false);
//         onClose();
//       }, 2000);
//     } catch (error) {
//       setStatus('Error generating file: ' + error.message);
//       setIsPrinting(false);
//     }
//   };

//   // Method 3: Server-side printing
//   const handleServerPrint = async () => {
//     setIsPrinting(true);
//     setStatus('Sending to server printer...');
    
//     try {
//       const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/print/appointment`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ 
//           appointment,
//           type: 'thermal',
//           timestamp: new Date().toISOString()
//         }),
//       });
      
//       if (response.ok) {
//         const result = await response.json();
//         setStatus('Print job sent to server successfully!');
//         setTimeout(() => {
//           setIsPrinting(false);
//           onClose();
//         }, 1500);
//       } else {
//         throw new Error('Server returned error: ' + response.status);
//       }
//     } catch (error) {
//       setStatus('Server printing failed: ' + error.message);
//       // Fallback to browser print
//       setTimeout(() => {
//         setStatus('Falling back to browser print...');
//         handleBrowserPrint();
//       }, 1500);
//     }
//   };

//   // Method 4: Image-based print for better compatibility
//   const handleImagePrint = () => {
//     setIsPrinting(true);
//     setStatus('Generating printable image...');
    
//     const printContent = `
//       <!DOCTYPE html>
//       <html>
//       <head>
//         <title>Print Receipt</title>
//         <style>
//           @page { margin: 0; size: 80mm auto; }
//           body { 
//             margin: 2mm; 
//             font-family: Arial, sans-serif;
//             font-size: 9px;
//             line-height: 1.1;
//             width: 76mm;
//           }
//           .container { 
//             border: 1px solid #000; 
//             padding: 3mm;
//             text-align: center;
//           }
//           .header { font-size: 11px; font-weight: bold; margin-bottom: 2mm; }
//           .channel { font-size: 14px; font-weight: bold; margin: 3mm 0; border: 2px solid #000; padding: 2mm; }
//           .important { background: #000; color: #fff; padding: 2mm; margin: 2mm 0; }
//           .footer { margin-top: 3mm; font-weight: bold; }
//         </style>
//       </head>
//       <body>
//         <div class="container">
//           <div class="header">AURA MEDITATION CENTER<br>APPOINTMENT CONFIRMATION</div>
//           <div style="border-bottom: 1px solid #000; margin: 2mm 0;"></div>
//           <div style="text-align: left;">
//             <div><strong>Patient:</strong> ${appointment?.MAD_FULL_NAME || 'N/A'}</div>
//             <div><strong>Time:</strong> ${formatTime(appointment?.MAD_ALLOCATED_TIME)}</div>
//             <div><strong>Contact:</strong> ${appointment?.MAD_CONTACT || 'N/A'}</div>
//             <div><strong>Date:</strong> ${new Date().toLocaleDateString('en-LK')}</div>
//           </div>
//           <div style="border-bottom: 1px solid #000; margin: 2mm 0;"></div>
//           <div class="channel">CHANNEL NUMBER<br>${appointment?.MAD_PATIENT_NO || 'N/A'}</div>
//           <div style="border-bottom: 1px solid #000; margin: 2mm 0;"></div>
//           <div class="important">ARRIVE 30 MINUTES EARLY</div>
//           <div class="footer">THANK YOU!<br>Aura Meditation Center</div>
//           <div style="font-size: 7px; margin-top: 3mm;">Printed: ${new Date().toLocaleString('en-LK')}</div>
//         </div>
//         <script>
//           setTimeout(() => window.print(), 500);
//           setTimeout(() => window.close(), 2000);
//         </script>
//       </body>
//       </html>
//     `;

//     const printWindow = window.open('', '_blank');
//     printWindow.document.write(printContent);
//     printWindow.document.close();
    
//     setTimeout(() => {
//       setIsPrinting(false);
//       onClose();
//     }, 3000);
//   };

//   const handlePrint = () => {
//     switch (printMethod) {
//       case 'browser':
//         handleBrowserPrint();
//         break;
//       case 'server':
//         handleServerPrint();
//         break;
//       case 'download':
//         handleDownloadEscPos();
//         break;
//       case 'image':
//         handleImagePrint();
//         break;
//       default:
//         handleBrowserPrint();
//     }
//   };

//   const printMethods = [
//     {
//       id: 'browser',
//       name: 'Browser Thermal Print',
//       description: 'Optimized for thermal printers with proper formatting',
//       icon: <PrintIcon />,
//     },
//     {
//       id: 'image',
//       name: 'Simple Print',
//       description: 'Basic printable format for any printer',
//       icon: <PrintIcon />,
//     },
//     {
//       id: 'download',
//       name: 'Download ESC/POS File',
//       description: 'Download file for manual transfer to thermal printer',
//       icon: <DownloadIcon />,
//     },
//     {
//       id: 'server',
//       name: 'Server Print',
//       description: 'Send to network/shared printer',
//       icon: <CloudUploadIcon />,
//     }
//   ];

//   return (
//     <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
//       <DialogTitle>
//         Print Appointment Receipt
//       </DialogTitle>
//       <DialogContent>
//         <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
//           Select printing method for thermal receipt
//         </Typography>
        
//         <FormControl fullWidth sx={{ mb: 3 }}>
//           <Select
//             value={printMethod}
//             onChange={(e) => setPrintMethod(e.target.value)}
//             disabled={isPrinting}
//           >
//             {printMethods.map(method => (
//               <MenuItem key={method.id} value={method.id}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                   {method.icon}
//                   <Box>
//                     <Typography variant="body2" fontWeight="bold">
//                       {method.name}
//                     </Typography>
//                     <Typography variant="caption" color="text.secondary">
//                       {method.description}
//                     </Typography>
//                   </Box>
//                 </Box>
//               </MenuItem>
//             ))}
//           </Select>
//         </FormControl>

//         {/* Print Preview */}
//         <Card variant="outlined" sx={{ mb: 2 }}>
//           <CardContent>
//             <Typography variant="h6" gutterBottom>
//               Receipt Preview
//             </Typography>
//             <Paper 
//               sx={{ 
//                 p: 2, 
//                 backgroundColor: '#f5f5f5', 
//                 fontFamily: 'Courier New, monospace', 
//                 fontSize: '10px', 
//                 lineHeight: '1.2',
//                 border: '1px dashed #ccc'
//               }}
//             >
//               <div style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '12px' }}>
//                 AURA MEDITATION CENTER
//               </div>
//               <div style={{ borderBottom: '1px solid #000', margin: '3px 0' }}></div>
//               <div style={{ textAlign: 'center', fontWeight: 'bold' }}>APPOINTMENT CONFIRMATION</div>
//               <div style={{ borderBottom: '1px solid #000', margin: '3px 0' }}></div>
//               <div>Patient: {appointment?.MAD_FULL_NAME || 'N/A'}</div>
//               <div>Time: {formatTime(appointment?.MAD_ALLOCATED_TIME)}</div>
//               <div>Contact: {appointment?.MAD_CONTACT || 'N/A'}</div>
//               <div>Date: {new Date().toLocaleDateString('en-LK')}</div>
//               <div style={{ borderBottom: '1px solid #000', margin: '3px 0' }}></div>
//               <div style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '14px', margin: '5px 0' }}>
//                 CHANNEL NUMBER<br/>
//                 {appointment?.MAD_PATIENT_NO || 'N/A'}
//               </div>
//               <div style={{ borderBottom: '1px solid #000', margin: '3px 0' }}></div>
//               <div style={{ background: '#000', color: '#fff', textAlign: 'center', padding: '2px', margin: '3px 0' }}>
//                 ARRIVE 30 MINUTES EARLY
//               </div>
//               <div style={{ textAlign: 'center', fontWeight: 'bold' }}>
//                 THANK YOU!<br/>Aura Meditation Center
//               </div>
//             </Paper>
//           </CardContent>
//         </Card>

//         {status && (
//           <Alert severity="info" sx={{ mb: 2 }}>
//             {status}
//           </Alert>
//         )}
//       </DialogContent>
//       <DialogActions>
//         <Button onClick={onClose} disabled={isPrinting}>
//           Cancel
//         </Button>
//         <Button 
//           onClick={handlePrint}
//           variant="contained"
//           disabled={isPrinting}
//           startIcon={isPrinting ? <CircularProgress size={16} /> : <PrintIcon />}
//         >
//           {isPrinting ? 'Printing...' : 'Print Receipt'}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// // Universal Printing Component (Simplified)
// const UniversalPrintDialog = ({ 
//   open, 
//   onClose, 
//   appointment,
//   onThermalPrint
// }) => {
//   const [isPrinting, setIsPrinting] = useState(false);

//   const handleQuickPrint = () => {
//     onClose();
//     onThermalPrint();
//   };

//   return (
//     <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
//       <DialogTitle>
//         Print Options
//       </DialogTitle>
//       <DialogContent>
//         <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
//           Choose how to print the appointment receipt
//         </Typography>
        
//         <Grid container spacing={2}>
//           <Grid item xs={12}>
//             <Card 
//               variant="outlined" 
//               sx={{ cursor: 'pointer', '&:hover': { backgroundColor: 'action.hover' } }}
//               onClick={handleQuickPrint}
//             >
//               <CardContent>
//                 <Box display="flex" alignItems="center" gap={2}>
//                   <PrintIcon color="primary" />
//                   <Box>
//                     <Typography variant="h6">
//                       Thermal Receipt Print
//                     </Typography>
//                     <Typography variant="body2" color="text.secondary">
//                       Optimized for thermal printers with multiple format options
//                     </Typography>
//                   </Box>
//                 </Box>
//               </CardContent>
//             </Card>
//           </Grid>
//         </Grid>
//       </DialogContent>
//       <DialogActions>
//         <Button onClick={onClose}>
//           Cancel
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// // Keep the existing AppointmentsModal component exactly as is
// const AppointmentsModal = ({ 
//   open, 
//   onClose, 
//   appointments, 
//   searchTerm, 
//   onSearchChange, 
//   isLoading, 
//   onStatusUpdate, 
//   onAddRecord, 
//   onCancelAppointment, 
//   onPrintAppointment,
//   selectedSlotId,
//   onRefresh
// }) => {
//   // ... (keep the exact same AppointmentsModal component code from your original)
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));
//   const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));

//   const filteredAppointments = appointments.filter((appointment) =>
//     appointment.MAD_FULL_NAME.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   const formatTime = (timeString) => {
//     return new Date(`1970-01-01T${timeString}`).toLocaleTimeString("en-LK", {
//       hour: "numeric",
//       minute: "numeric",
//       hour12: true,
//     });
//   };

//   // Mobile drawer content
//   const mobileContent = (
//     <Box sx={{ p: 2 }}>
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
//         <Typography variant="h6" fontWeight="bold" color="primary">
//           Appointments
//         </Typography>
//         <Box>
//           <IconButton onClick={onRefresh} size="small" color="primary">
//             <RefreshIcon />
//           </IconButton>
//           <IconButton onClick={onClose} size="small">
//             <CloseIcon />
//           </IconButton>
//         </Box>
//       </Box>

//       <TextField
//         size="small"
//         fullWidth
//         placeholder="Search patients..."
//         value={searchTerm}
//         onChange={onSearchChange}
//         InputProps={{
//           startAdornment: (
//             <InputAdornment position="start">
//               <SearchIcon color="primary" />
//             </InputAdornment>
//           ),
//         }}
//         sx={{ mb: 2 }}
//       />

//       {isLoading ? (
//         <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
//           <CircularProgress />
//         </Box>
//       ) : filteredAppointments.length === 0 ? (
//         <Typography variant="body1" color="textSecondary" sx={{ textAlign: "center", py: 4 }}>
//           No appointments found for this timeslot
//         </Typography>
//       ) : (
//         <Box sx={{ maxHeight: '70vh', overflow: 'auto' }}>
//           {filteredAppointments.map((appointment) => (
//             <Card 
//               key={appointment.MAD_APPOINMENT_ID} 
//               sx={{ 
//                 mb: 2, 
//                 opacity: appointment.MAD_STATUS === "I" ? 0.6 : 1,
//                 backgroundColor: appointment.MAD_STATUS === "I" ? '#ffe6e6' : 'inherit'
//               }}
//             >
//               <CardContent sx={{ p: 2 }}>
//                 {/* Patient Header */}
//                 <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
//                   <Avatar sx={{ width: 40, height: 40, mr: 2 }}>
//                     {appointment.MAD_FULL_NAME.charAt(0)}
//                   </Avatar>
//                   <Box sx={{ flex: 1 }}>
//                     <Typography variant="subtitle1" fontWeight="bold">
//                       {appointment.MAD_FULL_NAME}
//                     </Typography>
//                     <Typography variant="body2" color="text.secondary">
//                       {appointment.MAD_CONTACT}
//                     </Typography>
//                   </Box>
//                   <Chip
//                     label={appointment.MAD_PATIENT_NO}
//                     color="primary"
//                     size="small"
//                   />
//                 </Box>

//                 <Divider sx={{ my: 1 }} />

//                 {/* Appointment Details */}
//                 <Box sx={{ mb: 2 }}>
//                   <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
//                     <Typography variant="body2" color="text.secondary">Time:</Typography>
//                     <Typography variant="body2" fontWeight="medium">
//                       {formatTime(appointment.MAD_ALLOCATED_TIME)}
//                     </Typography>
//                   </Box>
                  
//                   <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                     <Typography variant="body2" color="text.secondary">Status:</Typography>
//                     {appointment.MAD_STATUS === "I" ? (
//                       <Chip label="Cancelled" color="error" size="small" />
//                     ) : appointment.MAD_STATUS === "c" ? (
//                       <Chip
//                         icon={<CheckCircleIcon fontSize="small" />}
//                         label="Completed"
//                         color="success"
//                         size="small"
//                       />
//                     ) : appointment.TreatmentStatus === "C" ? (
//                       <Chip
//                         icon={<CheckCircleIcon fontSize="small" />}
//                         label="Completed"
//                         color="success"
//                         size="small"
//                       />
//                     ) : appointment.TreatmentStatus === "P" ? (
//                       <Chip
//                         icon={<CheckCircleIcon fontSize="small" />}
//                         label="Preparation Complete"
//                         color="info"
//                         size="small"
//                         clickable
//                         onClick={() => onStatusUpdate(appointment)}
//                       />
//                     ) : (
//                       <Chip
//                         icon={<PendingIcon fontSize="small" />}
//                         label="Preparation Complete"
//                         color="warning"
//                         size="small"
//                         clickable
//                         onClick={() => onStatusUpdate(appointment)}
//                       />
//                     )}
//                   </Box>
//                 </Box>

//                 <Divider sx={{ my: 1 }} />

//                 {/* Action Buttons */}
//                 <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
//                   <Button
//                     variant="outlined"
//                     size="small"
//                     fullWidth
//                     startIcon={<AddIcon />}
//                     onClick={() => {
//                       onAddRecord(
//                         appointment.MAD_PATIENT_CODE,
//                         appointment.MAD_APPOINMENT_ID,
//                         appointment.MAD_PATIENT_NO
//                       );
//                       onClose();
//                     }}
//                     disabled={appointment.MAD_STATUS === "I" || appointment.TreatmentStatus === "C"}
//                   >
//                     Add Treatment
//                   </Button>
                  
//                   <Button
//                     variant="outlined"
//                     size="small"
//                     color="error"
//                     fullWidth
//                     startIcon={<CloseIcon />}
//                     onClick={() => onCancelAppointment(appointment.MAD_APPOINMENT_ID)}
//                     disabled={appointment.MAD_STATUS === "I" || appointment.TreatmentStatus === "C"}
//                   >
//                     Cancel Appointment
//                   </Button>
                  
//                   <Button
//                     variant="contained"
//                     size="small"
//                     color="secondary"
//                     fullWidth
//                     startIcon={<PrintIcon />}
//                     onClick={() => onPrintAppointment(appointment)}
//                   >
//                     Print Receipt
//                   </Button>
//                 </Box>
//               </CardContent>
//             </Card>
//           ))}
//         </Box>
//       )}
//     </Box>
//   );

//   // Desktop table content
//   const desktopContent = (
//     <>
//       <DialogTitle>
//         <Box display="flex" justifyContent="space-between" alignItems="center">
//           <Typography variant="h5" component="h2" fontWeight="bold" color="primary">
//             Appointments
//           </Typography>
//           <Box display="flex" alignItems="center" gap={1}>
//             <Button
//               startIcon={<RefreshIcon />}
//               onClick={onRefresh}
//               size="small"
//               variant="outlined"
//             >
//               Refresh
//             </Button>
//             <IconButton onClick={onClose}>
//               <CloseIcon />
//             </IconButton>
//           </Box>
//         </Box>
//       </DialogTitle>
      
//       <DialogContent dividers>
//         <Box sx={{ mb: 2 }}>
//           <TextField
//             size="small"
//             fullWidth
//             placeholder="Search patients..."
//             value={searchTerm}
//             onChange={onSearchChange}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start" sx={{ color: "primary.main" }}>
//                   <SearchIcon />
//                 </InputAdornment>
//               ),
//             }}
//           />
//         </Box>

//         {isLoading ? (
//           <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
//             <CircularProgress />
//           </Box>
//         ) : filteredAppointments.length === 0 ? (
//           <Typography variant="body1" color="textSecondary" sx={{ textAlign: "center", py: 4 }}>
//             No appointments found for this timeslot
//           </Typography>
//         ) : (
//           <TableContainer>
//             <Table size="medium">
//               <TableHead sx={{ backgroundColor: theme.palette.primary.light }}>
//                 <TableRow>
//                   <TableCell sx={{ color: "white", fontWeight: "bold" }}>Patient</TableCell>
//                   <TableCell sx={{ color: "white", fontWeight: "bold" }}>Contact</TableCell>
//                   <TableCell sx={{ color: "white", fontWeight: "bold" }}>Time</TableCell>
//                   <TableCell align="center" sx={{ color: "white", fontWeight: "bold" }}>No.</TableCell>
//                   <TableCell align="center" sx={{ color: "white", fontWeight: "bold" }}>Status</TableCell>
//                   <TableCell align="center" sx={{ color: "white", fontWeight: "bold" }}>Action</TableCell>
//                 </TableRow>
//               </TableHead>

//               <TableBody>
//                 {filteredAppointments.map((appointment) => (
//                   <TableRow
//                     key={appointment.MAD_APPOINMENT_ID}
//                     hover
//                     sx={{
//                       opacity: appointment.MAD_STATUS === "I" ? 0.6 : 1,
//                       backgroundColor: appointment.MAD_STATUS === "I" ? '#ffe6e6' : 'inherit'
//                     }}
//                   >
//                     <TableCell>
//                       <Box sx={{ display: "flex", alignItems: "center" }}>
//                         <Avatar sx={{ width: 32, height: 32, mr: 1 }}>
//                           {appointment.MAD_FULL_NAME.charAt(0)}
//                         </Avatar>
//                         {appointment.MAD_FULL_NAME}
//                       </Box>
//                     </TableCell>
//                     <TableCell>{appointment.MAD_CONTACT}</TableCell>
//                     <TableCell>
//                       {formatTime(appointment.MAD_ALLOCATED_TIME)}
//                     </TableCell>
//                     <TableCell align="center">
//                       <Chip
//                         label={appointment.MAD_PATIENT_NO}
//                         color="primary"
//                         size="small"
//                       />
//                     </TableCell>
                   
//                     <TableCell align="center">
//                       {appointment.MAD_STATUS === "I" ? (
//                         <Chip
//                           label="Cancelled"
//                           color="error"
//                           size="small"
//                         />
//                       ) : appointment.MAD_STATUS === "c" ? (
//                           <Chip
//                             icon={<CheckCircleIcon fontSize="small" />}
//                             label="Completed"
//                             color="success"
//                             size="small"
//                           />
//                         ): appointment.TreatmentStatus === "C" ? (
//                         <Chip
//                           icon={<CheckCircleIcon fontSize="small" />}
//                           label="Completed"
//                           color="success"
//                           size="small"
//                         />
//                       ) : appointment.TreatmentStatus === "P" ? (
//                         <Chip
//                           icon={<CheckCircleIcon fontSize="small" />}
//                           label="Preparation Complete"
//                           color="info"
//                           size="small"
//                           clickable
//                           onClick={() => onStatusUpdate(appointment)}
//                         />
//                       ) : (
//                         <Chip
//                           icon={<PendingIcon fontSize="small" />}
//                           label="Preparation Complete"
//                           color="warning"
//                           size="small"
//                           clickable
//                           onClick={() => onStatusUpdate(appointment)}
//                         />
//                       )}
//                     </TableCell>
//                     <TableCell align="center" sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
//                       <Button
//                         variant="outlined"
//                         size="small"
//                         startIcon={<AddIcon />}
//                         onClick={() => {
//                           onAddRecord(
//                             appointment.MAD_PATIENT_CODE,
//                             appointment.MAD_APPOINMENT_ID,
//                             appointment.MAD_PATIENT_NO
//                           );
//                           onClose();
//                         }}
//                         disabled={appointment.MAD_STATUS === "I" || appointment.TreatmentStatus === "C"}
//                       >
//                         Add Treatment
//                       </Button>
//                       <Button
//                         variant="outlined"
//                         size="small"
//                         color="error"
//                         startIcon={<CloseIcon />}
//                         onClick={() => onCancelAppointment(appointment.MAD_APPOINMENT_ID)}
//                         disabled={appointment.MAD_STATUS === "I" || appointment.TreatmentStatus === "C"}
//                       >
//                         Cancel
//                       </Button>
                      
//                       {/* <Button
//                         variant="contained"
//                         size="small"
//                         color="secondary"
//                         startIcon={<PrintIcon />}
//                         onClick={() => onPrintAppointment(appointment)}
//                       >
//                         Receipt
//                       </Button> */}
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         )}
//       </DialogContent>
//     </>
//   );

//   if (isMobile) {
//     return (
//       <Drawer
//         anchor="bottom"
//         open={open}
//         onClose={onClose}
//         sx={{
//           '& .MuiDrawer-paper': {
//             borderTopLeftRadius: 16,
//             borderTopRightRadius: 16,
//             maxHeight: '90vh',
//           },
//         }}
//       >
//         {mobileContent}
//       </Drawer>
//     );
//   }

//   return (
//     <Dialog
//       open={open}
//       onClose={onClose}
//       fullWidth
//       maxWidth="lg"
//     >
//       {desktopContent}
//     </Dialog>
//   );
// };

// // Main Component
// export default function DailyAppointment() {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//   const navigate = useNavigate();

//   const [timeslots, setTimeslots] = useState([]);
//   const [error, setError] = useState(null);
//   const [appointments, setAppointments] = useState([]);
//   const [selectedSlotId, setSelectedSlotId] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [snackbarSeverity, setSnackbarSeverity] = useState("info");
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [universalPrintDialogOpen, setUniversalPrintDialogOpen] = useState(false);
//   const [thermalPrintDialogOpen, setThermalPrintDialogOpen] = useState(false);
//   const [selectedAppointment, setSelectedAppointment] = useState(null);
//   const [selectedDate, setSelectedDate] = useState(() => {
//     const now = new Date();
//     const year = now.getFullYear();
//     const month = String(now.getMonth() + 1).padStart(2, '0');
//     const day = String(now.getDate()).padStart(2, '0');
//     return `${year}-${month}-${day}`;
//   });

//   const showSnackbar = (message, severity = "info") => {
//     setSnackbarMessage(message);
//     setSnackbarSeverity(severity);
//     setSnackbarOpen(true);
//   };

//   const handleSnackbarClose = () => {
//     setSnackbarOpen(false);
//   };

//   // Auto-refresh appointments every 1 minute when modal is open
//   useEffect(() => {
//     let intervalId;

//     if (isModalOpen && selectedSlotId) {
//       // Refresh immediately when modal opens
//       handleRefreshAppointments();

//       // Set up interval for auto-refresh every 1 minute
//       intervalId = setInterval(() => {
//         handleRefreshAppointments();
//       }, 60000); // 60 seconds = 1 minute

//       showSnackbar("Auto-refresh enabled - updating every minute", "info");
//     }

//     // Cleanup interval on modal close or component unmount
//     return () => {
//       if (intervalId) {
//         clearInterval(intervalId);
//         console.log("Auto-refresh interval cleared");
//       }
//     };
//   }, [isModalOpen, selectedSlotId]);

//   const fetchTimeslotsByDate = async () => {
//     setIsLoading(true);
//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_API_BASE_URL}/Timeslot/active-timeslots?date=${selectedDate}`
//       );
//       setTimeslots(response.data);
//       setError(null);
//     } catch (error) {
//       setTimeslots([]);
//       setError("No timeslots available for the selected date.");
//       console.error("Error fetching timeslots:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (selectedDate) {
//       fetchTimeslotsByDate();
//     }
//   }, [selectedDate]);

//   const handleViewAppointments = async (slotId) => {
//     setIsLoading(true);
//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_API_BASE_URL}/Appointment/appointments/${slotId}`
//       );
//       setAppointments(response.data);
//       setSelectedSlotId(slotId);
//       setIsModalOpen(true);
//       showSnackbar(`Loaded ${response.data.length} appointments`, "success");
//     } catch (error) {
//       console.error("Error fetching appointments:", error);
//       showSnackbar("No appointments available for this timeslot", "info");
//       setAppointments([]);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // Manual refresh function
//   const handleRefreshAppointments = async () => {
//     if (!selectedSlotId) return;
    
//     try {
//       console.log("Refreshing appointments...");
//       const response = await axios.get(
//         `${process.env.REACT_APP_API_BASE_URL}/Appointment/appointments/${selectedSlotId}`
//       );
//       setAppointments(response.data);
//       console.log(`Refreshed ${response.data.length} appointments`);
//     } catch (error) {
//       console.error("Error refreshing appointments:", error);
//       showSnackbar("Failed to refresh appointments", "error");
//     }
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setSelectedSlotId(null);
//     setSearchTerm("");
//   };

//   const handleStatusUpdate = async (appointment) => {
//     try {
//       const patientCode = appointment.MAD_PATIENT_CODE;
//       const appointmentID = appointment.MAD_APPOINMENT_ID;
//       const phoneNumber = appointment.MAD_CONTACT; 
      
//       console.log('Updating status with:', { patientCode, appointmentID });  
//       const response = await axios.put(
//         `${process.env.REACT_APP_API_BASE_URL}/Appointment/status/${appointmentID}`,
//         JSON.stringify("c"), 
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );
//       if (response.status === 200) {
//         console.log('Status updated successfully');
//         if (phoneNumber) {
//         try {
//           const smsResponse = await axios.post(
//             `${process.env.REACT_APP_API_BASE_URL}/Treatment/send-sms`,
//             {
//               Phone: phoneNumber
//             },
//             {
//               headers: {
//                 "Content-Type": "application/json",
//               },
//             }
//           );
          
//           if (smsResponse.status === 200) {
//             console.log('SMS sent successfully');
//             showSnackbar("Status updated to completed and SMS sent", "success");
//           }
//         } catch (smsError) {
//           console.error('Error sending SMS:', smsError);
//           showSnackbar("Status updated but failed to send SMS", "warning");
//         }
//       } else {
//         showSnackbar("Status updated to completed (no phone number for SMS)", "success");
//       }
//         // Refresh the appointments data
//         handleRefreshAppointments();
//       }
//     } catch (error) {
//       console.error('Error updating status:', error);
//       showSnackbar("Failed to update status", "error");
//     }
//   };

//   const handleAddRecord = (patientId, appointmentID, patientNo) => {
//     navigate(`/dashboard/addrecord/${patientId}`, {
//       state: { appointmentid: appointmentID, channelnumber: patientNo, MTD_APPOINMENT_ID: appointmentID },
//     });
//   };

//   const handlePrintAppointment = (appointment) => {
//     setSelectedAppointment(appointment);
//     setUniversalPrintDialogOpen(true);
//   };

//   const handleThermalPrint = () => {
//     setThermalPrintDialogOpen(true);
//   };

//   const handleDateChange = (e) => {
//     setSelectedDate(e.target.value);
//     setAppointments([]);
//     setSelectedSlotId(null);
//   };

//   const formatTime = (timeString) => {
//     return new Date(`1970-01-01T${timeString}`).toLocaleTimeString("en-LK", {
//       hour: "numeric",
//       minute: "numeric",
//       hour12: true,
//     });
//   };

//   const handleCancelAppointment = async (appointmentId) => {
//     try {
//       setIsLoading(true);
//       await axios.delete(
//         `${process.env.REACT_APP_API_BASE_URL}/Appointment/cancel-appointment/${appointmentId}`
//       );

//       setAppointments(appointments.map(appt =>
//         appt.MAD_APPOINMENT_ID === appointmentId
//           ? { ...appt, MAD_STATUS: "I" }
//           : appt
//       ));

//       showSnackbar("Appointment cancelled successfully", "success");
//     } catch (error) {
//       console.error("Error cancelling appointment:", error);
//       showSnackbar("Failed to cancel appointment", "error");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <Container maxWidth="xl" sx={{ py: 3 }}>
//       <Paper elevation={3} sx={{ p: 4 }}>
//         <Box
//           sx={{
//             mb: 4,
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//           }}
//         >
//           <Typography
//             variant="h4"
//             component="h1"
//             gutterBottom
//             color="primary"
//             fontWeight={600}
//             align="center"
//           >
//             Daily Appointments
//           </Typography>

        
//           <Box
//             sx={{
//               display: "flex",
//               flexDirection: isMobile ? "column" : "row",
//               gap: 2,
//               mb: 3,
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//           >
//             <TextField
//               type="date"
//               label="Select Date"
//               value={selectedDate}
//               onChange={handleDateChange}
//               InputLabelProps={{ shrink: true }}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <DateRangeIcon sx={{ color: "primary.main" }} />
//                   </InputAdornment>
//                 ),
//               }}
//               inputProps={{
//                 placeholder: "YYYY/MM/DD"
//               }}
//               sx={{
//                 minWidth: isMobile ? "100%" : 250,
//                 '& .MuiInputBase-input': {
//                   position: 'relative',
//                   backgroundColor: 'transparent',
//                 },
//                 '& input[type="date"]': {
//                   color: 'transparent',
//                   position: 'relative',
//                   '&::-webkit-calendar-picker-indicator': {
//                     opacity: 0,
//                     position: 'absolute',
//                     left: 0,
//                     top: 0,
//                     width: '100%',
//                     height: '100%',
//                     cursor: 'pointer',
//                     zIndex: 2,
//                   },
//                 },
//                 '& .MuiInputBase-root': {
//                   position: 'relative',
//                   '&::after': {
//                     content: selectedDate
//                       ? `"${selectedDate.split('-').join('/')}"`
//                       : '"YYYY/MM/DD"',
//                     position: 'absolute',
//                     left: '40px',
//                     top: '50%',
//                     transform: 'translateY(-50%)',
//                     color: selectedDate ? 'rgba(0, 0, 0, 0.87)' : 'rgba(0, 0, 0, 0.6)',
//                     fontSize: '14px',
//                     fontFamily: 'inherit',
//                     pointerEvents: 'none',
//                     zIndex: 1,
//                   }
//                 }
//               }}
//             />
//           </Box>
//         </Box>

//         {isLoading && !selectedSlotId ? (
//           <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
//             <CircularProgress />
//           </Box>
//         ) : error ? (
//           <Paper elevation={3} sx={{ p: 3, textAlign: "center" }}>
//             <Typography variant="h6" color="textSecondary">
//               {error}
//             </Typography>
//           </Paper>
//         ) : (
//           <Grid container spacing={3}>
//             <Grid item xs={12}>
//               <Typography
//                 variant="h6"
//                 gutterBottom
//                 color="primary"
//                 fontWeight={600}
//               >
//                 Available Timeslots
//               </Typography>
//               <Grid container spacing={2}>
//                 {timeslots.map((timeslot) => (
//                   <Grid item xs={12} key={timeslot.MT_SLOT_ID}>
//                     <Card
//                       elevation={3}
//                       sx={{
//                         borderLeft:
//                           selectedSlotId === timeslot.MT_SLOT_ID
//                             ? `4px solid ${theme.palette.primary.main}`
//                             : "none",
//                         cursor: "pointer",
//                         "&:hover": {
//                           boxShadow: 4,
//                         },
//                       }}
//                       onClick={() =>
//                         handleViewAppointments(timeslot.MT_SLOT_ID)
//                       }
//                     >
//                       <CardContent>
//                         <Box
//                           sx={{ display: "flex", alignItems: "center", mb: 1 }}
//                         >
//                           <Avatar
//                             sx={{ bgcolor: theme.palette.primary.main, mr: 2 }}
//                           >
//                             <PersonIcon />
//                           </Avatar>
//                           <Typography variant="subtitle1">
//                             {timeslot.MT_DOCTOR}
//                           </Typography>
//                         </Box>
//                         <Box sx={{ display: "flex", alignItems: "center" }}>
//                           <TimeIcon color="action" sx={{ mr: 1 }} />
//                           <Typography>
//                             {formatTime(timeslot.MT_START_TIME)} -{" "}
//                             {formatTime(timeslot.MT_END_TIME)}
//                           </Typography>
//                         </Box>
//                       </CardContent>
//                     </Card>
//                   </Grid>
//                 ))}
//               </Grid>
//             </Grid>
//           </Grid>
//         )}

//         {/* Responsive Appointments Modal */}
//         <AppointmentsModal
//           open={isModalOpen}
//           onClose={handleCloseModal}
//           appointments={appointments}
//           searchTerm={searchTerm}
//           onSearchChange={(e) => setSearchTerm(e.target.value)}
//           isLoading={isLoading}
//           onStatusUpdate={handleStatusUpdate}
//           onAddRecord={handleAddRecord}
//           onCancelAppointment={handleCancelAppointment}
//           onPrintAppointment={handlePrintAppointment}
//           selectedSlotId={selectedSlotId}
//           onRefresh={handleRefreshAppointments}
//         />

//         {/* Universal Printing Dialog */}
//         <UniversalPrintDialog
//           open={universalPrintDialogOpen}
//           onClose={() => setUniversalPrintDialogOpen(false)}
//           appointment={selectedAppointment}
//           onThermalPrint={handleThermalPrint}
//         />

//         {/* Thermal Printing Dialog */}
//         <ThermalPrintDialog
//           open={thermalPrintDialogOpen}
//           onClose={() => setThermalPrintDialogOpen(false)}
//           appointment={selectedAppointment}
//         />

//         <Snackbar
//           open={snackbarOpen}
//           autoHideDuration={6000}
//           onClose={handleSnackbarClose}
//           anchorOrigin={{ vertical: "top", horizontal: "right" }}
//         >
//           <Alert
//             onClose={handleSnackbarClose}
//             severity={snackbarSeverity}
//             sx={{ width: "100%" }}
//           >
//             {snackbarMessage}
//           </Alert>
//         </Snackbar>
//       </Paper>
//     </Container>
//   );
// }





























import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useTheme,
  useMediaQuery,
  Snackbar,
  Alert,
  Chip,
  Avatar,
  InputAdornment,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Stack,
} from "@mui/material";
import {
  Add as AddIcon,
  Delete as DeleteIcon,
  Search as SearchIcon,
  Person as PersonIcon,
  Email as EmailIcon,
  Category as CategoryIcon,
  MedicalServices as MedicalIcon,
  Close as CloseIcon,
  CheckCircle as CheckCircleIcon,
  Lock as LockIcon,
  AccessTime as TimeIcon,
  Pending as PendingIcon,
  CalendarMonth as CalendarIcon,
  EventNote as EventNoteIcon,
  People as PeopleIcon,
  Today as TodayIcon,
  ArrowBack as ArrowBackIcon,
  PersonOff as PersonOffIcon,
  HourglassEmpty as HourglassIcon,
  Phone as PhoneIcon,
  WatchLater as WatchLaterIcon,
  DateRange as DateRangeIcon,
  EventAvailable as EventAvailableIcon,
  EventBusy as EventBusyIcon,
  Schedule as ScheduleIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon,
  KeyboardArrowUp as KeyboardArrowUpIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
  CalendarToday as CalendarTodayIcon,
  ViewWeek as ViewWeekIcon,
  ViewModule as ViewModuleIcon,
  TrendingUp as TrendingUpIcon,
} from "@mui/icons-material";

/* ─────────────────────────────────────────────
   CONSTANTS & HELPERS
───────────────────────────────────────────── */
const BRAND = {
  main: "#1976d2",
  dark: "#115293",
  light: "#42a5f5",
  bg: "#e3f2fd",
};

const toISO = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
    d.getDate()
  ).padStart(2, "0")}`;

const formatTime = (t) =>
  new Date(`1970-01-01T${t}`).toLocaleTimeString("en-LK", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });

const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

const getWeekDays = (date) => {
  const start = new Date(date);
  start.setDate(date.getDate() - date.getDay());
  const days = [];
  for (let i = 0; i < 7; i++) {
    const day = new Date(start);
    day.setDate(start.getDate() + i);
    days.push(day);
  }
  return days;
};

/* ─────────────────────────────────────────────
   MAIN COMPONENT
───────────────────────────────────────────── */
export default function DailyAppointment() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isMd = useMediaQuery(theme.breakpoints.down("md"));

  const navigate = useNavigate();
  // const Name = localStorage.getItem("Name") || "Doctor";
  const Name = "Primali Perera";

  /* ── state ── */
  const [viewMode, setViewMode] = useState("week"); // "week" or "month"
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(toISO(new Date()));
  const [timeslots, setTimeslots] = useState([]);
  const [appointments, setAppointments] = useState([]);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [loadingSlots, setLoadingSlots] = useState(false);
  const [loadingAppts, setLoadingAppts] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [slotStats, setSlotStats] = useState({});
  const [expandedSlot, setExpandedSlot] = useState(null);
  const [dateStats, setDateStats] = useState({});
  const [snack, setSnack] = useState({ open: false, msg: "", sev: "info" });

  const showSnack = (msg, sev = "info") => setSnack({ open: true, msg, sev });

  /* ── fetch timeslots ── */
  useEffect(() => {
    const run = async () => {
      setLoadingSlots(true);
      setTimeslots([]);
      setAppointments([]);
      setSelectedSlot(null);
      setExpandedSlot(null);
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/Timeslot/timeslotcard/${selectedDate}/${Name}`
        );
        setTimeslots(res.data);
        
        // Fetch appointments for each slot to get stats
        const stats = {};
        for (const slot of res.data) {
          try {
            const apptRes = await axios.get(
              `${process.env.REACT_APP_API_BASE_URL}/Appointment/appointments/${slot.MT_SLOT_ID}`
            );
            const appts = apptRes.data;
            stats[slot.MT_SLOT_ID] = {
              total: appts.length,
              pending: appts.filter(a => a.MAD_STATUS !== "I" && !a.TreatmentStatus).length,
              completed: appts.filter(a => a.TreatmentStatus === "C").length,
              cancelled: appts.filter(a => a.MAD_STATUS === "I").length,
              appointments: appts,
            };
          } catch {
            stats[slot.MT_SLOT_ID] = { total: 0, pending: 0, completed: 0, cancelled: 0, appointments: [] };
          }
        }
        setSlotStats(stats);
      } catch {
        showSnack("No timeslots found for selected date", "info");
      } finally {
        setLoadingSlots(false);
      }
    };
    if (selectedDate) run();
  }, [selectedDate, Name]);

  /* ── fetch date stats for calendar view ── */
  useEffect(() => {
    const fetchDateStats = async () => {
      const year = currentDate.getFullYear();
      const month = currentDate.getMonth();
      const daysInMonth = new Date(year, month + 1, 0).getDate();
      const stats = {};
      
      for (let day = 1; day <= daysInMonth; day++) {
        const dateStr = `${year}-${String(month + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/Timeslot/timeslotcard/${dateStr}/${Name}`
          );
          let totalBookings = 0;
          for (const slot of res.data) {
            try {
              const apptRes = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/Appointment/appointments/${slot.MT_SLOT_ID}`
              );
              totalBookings += apptRes.data.length;
            } catch {
              // No appointments
            }
          }
          stats[dateStr] = {
            slots: res.data.length,
            bookings: totalBookings,
          };
        } catch {
          stats[dateStr] = { slots: 0, bookings: 0 };
        }
      }
      setDateStats(stats);
    };
    
    fetchDateStats();
  }, [currentDate, Name]);

  /* ── fetch appointments for selected slot ── */
  const handleViewSlot = async (slot) => {
    if (expandedSlot === slot.MT_SLOT_ID) {
      setExpandedSlot(null);
      setSelectedSlot(null);
      setAppointments([]);
      return;
    }

    setLoadingAppts(true);
    setSelectedSlot(slot);
    setSearchTerm("");
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/Appointment/appointments/${slot.MT_SLOT_ID}`
      );
      setAppointments(res.data);
      setExpandedSlot(slot.MT_SLOT_ID);
    } catch {
      showSnack("No appointments available for this timeslot", "info");
      setAppointments([]);
    } finally {
      setLoadingAppts(false);
    }
  };

  const handleCancelAppointment = async (appointmentId) => {
    try {
      await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/Appointment/cancel-appointment/${appointmentId}`
      );
      setAppointments((prev) =>
        prev.map((a) =>
          a.MAD_APPOINMENT_ID === appointmentId
            ? { ...a, MAD_STATUS: "I" }
            : a
        )
      );
      showSnack("Appointment cancelled successfully", "success");
    } catch {
      showSnack("Failed to cancel appointment", "error");
    }
  };

  const handleAddRecord = (patientId, appointmentID, patientNo) => {
    navigate(`/dashboard/addrecord/${patientId}`, {
      state: {
        appointmentid: appointmentID,
        channelnumber: patientNo,
        MTD_APPOINMENT_ID: appointmentID,
      },
    });
  };

  /* ── calendar generation ── */
  const weekDays = getWeekDays(currentDate);
  const monthDays = [];
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  
  for (let i = 1; i <= daysInMonth; i++) {
    monthDays.push(new Date(year, month, i));
  }

  /* ── gradient ── */
  const grad = `linear-gradient(135deg, ${BRAND.dark} 0%, ${BRAND.main} 55%, ${BRAND.light} 100%)`;

  /* ── calculate totals for cards ── */
  const totalSlots = timeslots.length;
  const totalBookings = Object.values(slotStats).reduce((sum, stat) => sum + stat.total, 0);
  const totalPending = Object.values(slotStats).reduce((sum, stat) => sum + stat.pending, 0);
  const totalCompleted = Object.values(slotStats).reduce((sum, stat) => sum + stat.completed, 0);
  const totalCancelled = Object.values(slotStats).reduce((sum, stat) => sum + stat.cancelled, 0);

  /* ─────────────────────── RENDER ─────────────────────── */
  return (
    <Container maxWidth="xl" sx={{ py: 2 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography
          variant="h4"
          component="h1"
          gutterBottom
          color="primary"
          fontWeight={600}
          align="center"
        >
          Appointment Schedule
        </Typography>
        
        <Typography variant="subtitle1" align="center" color="text.secondary" gutterBottom>
          Dr. {Name} · {MONTHS[currentDate.getMonth()]} {currentDate.getFullYear()}
        </Typography>

        {/* View Toggle */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: 2,
            mb: 3,
            mt: 2,
          }}
        >
          <Button
            variant={viewMode === "week" ? "contained" : "outlined"}
            onClick={() => setViewMode("week")}
            startIcon={<ViewWeekIcon />}
          >
            Week
          </Button>
          <Button
            variant={viewMode === "month" ? "contained" : "outlined"}
            onClick={() => setViewMode("month")}
            startIcon={<ViewModuleIcon />}
          >
            Month
          </Button>
        </Box>

        {/* Summary Cards */}
        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={6} sm={3}>
            <Card elevation={2}>
              <CardContent>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Box
                    sx={{
                      width: 48,
                      height: 48,
                      borderRadius: "12px",
                      background: `${BRAND.main}20`,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <ScheduleIcon sx={{ color: BRAND.main, fontSize: 28 }} />
                  </Box>
                  <Box>
                    <Typography variant="h4" fontWeight={800} color={BRAND.dark}>
                      {totalSlots}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" fontWeight={500}>
                      Total Slots
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={6} sm={3}>
            <Card elevation={2}>
              <CardContent>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Box
                    sx={{
                      width: 48,
                      height: 48,
                      borderRadius: "12px",
                      background: "#fef3c7",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <HourglassIcon sx={{ color: "#f59e0b", fontSize: 28 }} />
                  </Box>
                  <Box>
                    <Typography variant="h4" fontWeight={800} color="#f59e0b">
                      {totalPending}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" fontWeight={500}>
                      Pending
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={6} sm={3}>
            <Card elevation={2}>
              <CardContent>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Box
                    sx={{
                      width: 48,
                      height: 48,
                      borderRadius: "12px",
                      background: "#dcfce7",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <CheckCircleIcon sx={{ color: "#16a34a", fontSize: 28 }} />
                  </Box>
                  <Box>
                    <Typography variant="h4" fontWeight={800} color="#16a34a">
                      {totalCompleted}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" fontWeight={500}>
                      Completed
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={6} sm={3}>
            <Card elevation={2}>
              <CardContent>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Box
                    sx={{
                      width: 48,
                      height: 48,
                      borderRadius: "12px",
                      background: "#fee2e2",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <PersonOffIcon sx={{ color: "#dc2626", fontSize: 28 }} />
                  </Box>
                  <Box>
                    <Typography variant="h4" fontWeight={800} color="#dc2626">
                      {totalCancelled}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" fontWeight={500}>
                      Cancelled
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* Calendar View */}
        <Card elevation={2} sx={{ mb: 3 }}>
          <CardContent>
            {/* Calendar Navigation */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mb: 2,
                flexWrap: "wrap",
                gap: 1,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <IconButton
                  onClick={() => {
                    const newDate = new Date(currentDate);
                    if (viewMode === "week") {
                      newDate.setDate(currentDate.getDate() - 7);
                    } else {
                      newDate.setMonth(currentDate.getMonth() - 1);
                    }
                    setCurrentDate(newDate);
                  }}
                >
                  <KeyboardArrowDownIcon />
                </IconButton>
                <Typography variant="h6" fontWeight={600}>
                  {viewMode === "week" 
                    ? `${weekDays[0].toLocaleDateString()} - ${weekDays[6].toLocaleDateString()}`
                    : `${MONTHS[currentDate.getMonth()]} ${currentDate.getFullYear()}`
                  }
                </Typography>
                <IconButton
                  onClick={() => {
                    const newDate = new Date(currentDate);
                    if (viewMode === "week") {
                      newDate.setDate(currentDate.getDate() + 7);
                    } else {
                      newDate.setMonth(currentDate.getMonth() + 1);
                    }
                    setCurrentDate(newDate);
                  }}
                >
                  <KeyboardArrowUpIcon />
                </IconButton>
              </Box>
              <Button
                variant="contained"
                startIcon={<TodayIcon />}
                onClick={() => setCurrentDate(new Date())}
                size="small"
              >
                Today
              </Button>
            </Box>

            {/* Calendar Grid */}
            {viewMode === "week" ? (
              // Week View - Horizontal Timeline
              <Box sx={{ display: "flex", gap: 1, overflowX: "auto", pb: 1 }}>
                {weekDays.map((day, index) => {
                  const dateStr = toISO(day);
                  const isToday = dateStr === toISO(new Date());
                  const isSelected = dateStr === selectedDate;
                  const stats = dateStats[dateStr] || { slots: 0, bookings: 0 };
                  
                  return (
                    <Card
                      key={index}
                      onClick={() => setSelectedDate(dateStr)}
                      sx={{
                        minWidth: 120,
                        cursor: "pointer",
                        border: `2px solid ${isSelected ? theme.palette.primary.main : 'transparent'}`,
                        bgcolor: isToday ? `${theme.palette.primary.main}10` : '#fff',
                        transition: "all 0.2s",
                        '&:hover': {
                          transform: "translateY(-4px)",
                          boxShadow: theme.shadows[4],
                        },
                      }}
                    >
                      <CardContent>
                        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                          {day.toLocaleDateString('en-US', { weekday: 'short' })}
                        </Typography>
                        <Typography variant="h4" fontWeight={700} color={isSelected ? theme.palette.primary.main : theme.palette.text.primary}>
                          {day.getDate()}
                        </Typography>
                        <Typography variant="caption" color="text.secondary" display="block">
                          {day.toLocaleDateString('en-US', { month: 'short' })}
                        </Typography>
                        
                        <Box sx={{ mt: 1, display: "flex", gap: 0.5, flexWrap: "wrap" }}>
                          {stats.slots > 0 && (
                            <Chip
                              size="small"
                              label={`${stats.slots} slots`}
                              sx={{ bgcolor: theme.palette.primary.light, color: '#fff', fontSize: '0.6rem', height: 20 }}
                            />
                          )}
                          {stats.bookings > 0 && (
                            <Chip
                              size="small"
                              label={`${stats.bookings} bks`}
                              sx={{ bgcolor: theme.palette.grey[200], fontSize: '0.6rem', height: 20 }}
                            />
                          )}
                        </Box>
                      </CardContent>
                    </Card>
                  );
                })}
              </Box>
            ) : (
              // Month View - Calendar Grid
              <Box>
                {/* Weekday headers */}
                <Grid container spacing={1} sx={{ mb: 1 }}>
                  {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day) => (
                    <Grid item xs key={day}>
                      <Typography align="center" variant="subtitle2" fontWeight={600} color="text.secondary">
                        {day}
                      </Typography>
                    </Grid>
                  ))}
                </Grid>
                
                {/* Calendar days */}
                <Grid container spacing={1}>
                  {Array.from({ length: new Date(year, month, 1).getDay() }).map((_, i) => (
                    <Grid item xs key={`empty-${i}`}>
                      <Box sx={{ height: 80 }} />
                    </Grid>
                  ))}
                  
                  {monthDays.map((day) => {
                    const dateStr = toISO(day);
                    const isToday = dateStr === toISO(new Date());
                    const isSelected = dateStr === selectedDate;
                    const stats = dateStats[dateStr] || { slots: 0, bookings: 0 };
                    
                    return (
                      <Grid item xs key={dateStr}>
                        <Paper
                          onClick={() => setSelectedDate(dateStr)}
                          elevation={0}
                          sx={{
                            height: 80,
                            p: 1,
                            cursor: "pointer",
                            border: `2px solid ${isSelected ? theme.palette.primary.main : 'transparent'}`,
                            bgcolor: isToday ? `${theme.palette.primary.main}10` : '#fff',
                            transition: "all 0.2s",
                            '&:hover': {
                              bgcolor: `${theme.palette.primary.main}05`,
                              transform: "scale(0.98)",
                            },
                          }}
                        >
                          <Typography 
                            variant="h6" 
                            fontWeight={isToday ? 700 : 500}
                            color={isSelected ? theme.palette.primary.main : isToday ? theme.palette.primary.main : 'text.primary'}
                          >
                            {day.getDate()}
                          </Typography>
                          
                          {stats.slots > 0 && (
                            <Box sx={{ mt: 0.5 }}>
                              <Chip
                                size="small"
                                label={`${stats.slots}`}
                                sx={{ 
                                  height: 18, 
                                  fontSize: '0.6rem',
                                  bgcolor: theme.palette.primary.main,
                                  color: '#fff',
                                  fontWeight: 600,
                                }}
                              />
                            </Box>
                          )}
                        </Paper>
                      </Grid>
                    );
                  })}
                </Grid>
              </Box>
            )}
          </CardContent>
        </Card>

        {/* Selected Date Info Bar */}
        <Paper
          elevation={2}
          sx={{
            p: 2,
            mb: 3,
            borderRadius: 2,
            bgcolor: theme.palette.primary.main,
            color: '#fff',
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <CalendarTodayIcon />
            <Box>
              <Typography variant="h6" fontWeight={700}>
                {new Date(selectedDate + "T00:00:00").toLocaleDateString("en-LK", {
                  weekday: "long",
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                {totalSlots} timeslot{totalSlots !== 1 ? 's' : ''} available · {totalBookings} total booking{totalBookings !== 1 ? 's' : ''}
              </Typography>
            </Box>
          </Box>
          
          <Box sx={{ display: "flex", gap: 1 }}>
            <Chip
              icon={<HourglassIcon />}
              label={`${totalPending} Pending`}
              sx={{ bgcolor: 'rgba(255,255,255,0.2)', color: '#fff', fontWeight: 600 }}
            />
            <Chip
              icon={<CheckCircleIcon />}
              label={`${totalCompleted} Completed`}
              sx={{ bgcolor: 'rgba(255,255,255,0.2)', color: '#fff', fontWeight: 600 }}
            />
            {totalCancelled > 0 && (
              <Chip
                icon={<PersonOffIcon />}
                label={`${totalCancelled} Cancelled`}
                sx={{ bgcolor: 'rgba(255,255,255,0.2)', color: '#fff', fontWeight: 600 }}
              />
            )}
          </Box>
        </Paper>

        {/* Timeslots Section */}
        <Card elevation={2}>
          <CardContent>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mb: 2,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <EventNoteIcon sx={{ color: theme.palette.primary.main }} />
                <Typography variant="h6" fontWeight={700} color={theme.palette.primary.dark}>
                  Today's Schedule
                </Typography>
              </Box>
              <Typography variant="body2" color="text.secondary">
                {timeslots.length} timeslot{timeslots.length !== 1 ? 's' : ''} available
              </Typography>
            </Box>

            {/* Timeslots List */}
            {loadingSlots ? (
              <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
                <CircularProgress sx={{ color: theme.palette.primary.main }} />
              </Box>
            ) : timeslots.length === 0 ? (
              <Box
                sx={{
                  textAlign: "center",
                  py: 8,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <EventBusyIcon sx={{ fontSize: 64, color: `${theme.palette.primary.main}30` }} />
                <Typography variant="h6" sx={{ color: "#64748b" }}>
                  No Timeslots Available
                </Typography>
                <Typography variant="body2" sx={{ color: "#94a3b8" }}>
                  Select a different date from the calendar
                </Typography>
              </Box>
            ) : (
              <Stack spacing={2}>
                {timeslots.map((slot) => {
                  const stats = slotStats[slot.MT_SLOT_ID] || { total: 0, pending: 0, completed: 0, cancelled: 0 };
                  const isExpanded = expandedSlot === slot.MT_SLOT_ID;
                  
                  return (
                    <Paper
                      key={slot.MT_SLOT_ID}
                      elevation={0}
                      sx={{
                        border: `1px solid ${isExpanded ? theme.palette.primary.main : theme.palette.divider}`,
                        borderRadius: 2,
                        overflow: "hidden",
                        transition: "all 0.3s ease",
                      }}
                    >
                      {/* Slot Header */}
                      <Box
                        onClick={() => handleViewSlot(slot)}
                        sx={{
                          p: 2,
                          display: "flex",
                          alignItems: "center",
                          gap: 2,
                          cursor: "pointer",
                          bgcolor: isExpanded ? `${theme.palette.primary.main}05` : '#fff',
                          '&:hover': {
                            bgcolor: `${theme.palette.primary.main}05`,
                          },
                        }}
                      >
                        <Avatar
                          sx={{
                            width: 48,
                            height: 48,
                            bgcolor: isExpanded ? theme.palette.primary.main : theme.palette.primary.light,
                            color: '#fff',
                            fontWeight: 800,
                          }}
                        >
                          {slot.MT_DOCTOR?.charAt(0).toUpperCase()}
                        </Avatar>

                        <Box sx={{ flex: 1 }}>
                          <Typography variant="h6" fontWeight={700}>
                            {slot.MT_DOCTOR}
                          </Typography>
                          <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "wrap", mt: 0.5 }}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                              <TimeIcon sx={{ fontSize: 16, color: theme.palette.primary.main }} />
                              <Typography variant="body2" color="text.secondary">
                                {formatTime(slot.MT_START_TIME)} - {formatTime(slot.MT_END_TIME)}
                              </Typography>
                            </Box>
                            
                            <Box sx={{ display: "flex", gap: 1 }}>
                              {stats.pending > 0 && (
                                <Chip
                                  size="small"
                                  label={`${stats.pending} Pending`}
                                  sx={{ bgcolor: "#fef3c7", color: "#b45309", fontWeight: 600 }}
                                />
                              )}
                              {stats.completed > 0 && (
                                <Chip
                                  size="small"
                                  label={`${stats.completed} Completed`}
                                  sx={{ bgcolor: "#dcfce7", color: "#15803d", fontWeight: 600 }}
                                />
                              )}
                            </Box>
                          </Box>
                        </Box>

                        <Box
                          sx={{
                            px: 2,
                            py: 0.5,
                            borderRadius: 1,
                            bgcolor: isExpanded ? theme.palette.primary.main : theme.palette.grey[200],
                            color: isExpanded ? '#fff' : theme.palette.text.primary,
                            fontWeight: 700,
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                          }}
                        >
                          <PeopleIcon sx={{ fontSize: 18 }} />
                          <Typography variant="body2" fontWeight={700}>
                            {stats.total}
                          </Typography>
                          {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </Box>
                      </Box>

                      {/* Expanded Appointments */}
                      {isExpanded && (
                        <Box sx={{ borderTop: `1px solid ${theme.palette.divider}`, p: 2, bgcolor: "#fafbfc" }}>
                          {loadingAppts ? (
                            <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
                              <CircularProgress size={32} sx={{ color: theme.palette.primary.main }} />
                            </Box>
                          ) : appointments.length === 0 ? (
                            <Box sx={{ textAlign: "center", py: 4 }}>
                              <EventAvailableIcon sx={{ fontSize: 48, color: `${theme.palette.primary.main}30`, mb: 1 }} />
                              <Typography color="text.secondary">No appointments in this slot</Typography>
                            </Box>
                          ) : (
                            <>
                              {/* Search */}
                              <TextField
                                size="small"
                                fullWidth
                                placeholder="Search patients..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                sx={{ mb: 2 }}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <SearchIcon sx={{ color: theme.palette.primary.main }} />
                                    </InputAdornment>
                                  ),
                                }}
                              />

                              {/* Appointments Table */}
                              <TableContainer>
                                <Table size={isMobile ? "small" : "medium"}>
                                  <TableHead>
                                    <TableRow sx={{ bgcolor: theme.palette.primary.light }}>
                                      <TableCell sx={{ fontWeight: 700, color: '#fff' }}>Patient</TableCell>
                                      {!isMobile && <TableCell sx={{ fontWeight: 700, color: '#fff' }}>Contact</TableCell>}
                                      <TableCell sx={{ fontWeight: 700, color: '#fff' }}>Time</TableCell>
                                      <TableCell sx={{ fontWeight: 700, color: '#fff' }}>No.</TableCell>
                                      <TableCell sx={{ fontWeight: 700, color: '#fff' }}>Status</TableCell>
                                      <TableCell align="center" sx={{ fontWeight: 700, color: '#fff' }}>Actions</TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {appointments
                                      .filter(a => 
                                        searchTerm ? 
                                        a.MAD_FULL_NAME.toLowerCase().includes(searchTerm.toLowerCase()) : 
                                        true
                                      )
                                      .map((appt) => {
                                        const isCancelled = appt.MAD_STATUS === "I";
                                        const isCompleted = appt.TreatmentStatus === "C";
                                        const disabled = isCancelled || isCompleted;

                                        return (
                                          <TableRow
                                            key={appt.MAD_APPOINMENT_ID}
                                            sx={{
                                              opacity: isCancelled ? 0.65 : 1,
                                              bgcolor: isCancelled ? "#fff5f5" : "inherit",
                                            }}
                                          >
                                            <TableCell>
                                              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                <Avatar
                                                  sx={{
                                                    width: 32,
                                                    height: 32,
                                                    bgcolor: isCancelled ? "#fee2e2" : theme.palette.primary.light,
                                                    color: isCancelled ? "#dc2626" : '#fff',
                                                    fontSize: 14,
                                                  }}
                                                >
                                                  {appt.MAD_FULL_NAME.charAt(0)}
                                                </Avatar>
                                                <Typography variant="body2" fontWeight={600}>
                                                  {appt.MAD_FULL_NAME}
                                                </Typography>
                                              </Box>
                                            </TableCell>
                                            
                                            {!isMobile && (
                                              <TableCell>
                                                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                                  <PhoneIcon sx={{ fontSize: 14, color: theme.palette.primary.main }} />
                                                  <Typography variant="body2">{appt.MAD_CONTACT}</Typography>
                                                </Box>
                                              </TableCell>
                                            )}
                                            
                                            <TableCell>
                                              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                                <WatchLaterIcon sx={{ fontSize: 14, color: theme.palette.primary.main }} />
                                                <Typography variant="body2">
                                                  {formatTime(appt.MAD_ALLOCATED_TIME)}
                                                </Typography>
                                              </Box>
                                            </TableCell>
                                            
                                            <TableCell>
                                              <Box
                                                sx={{
                                                  display: "inline-block",
                                                  px: 1.5,
                                                  py: 0.3,
                                                  borderRadius: 1,
                                                  border: `1px solid ${theme.palette.primary.main}`,
                                                  color: theme.palette.primary.main,
                                                  fontWeight: 700,
                                                  fontSize: "0.75rem",
                                                }}
                                              >
                                                {appt.MAD_PATIENT_NO}
                                              </Box>
                                            </TableCell>
                                            
                                            <TableCell>
                                              {appt.MAD_STATUS === "I" ? (
                                                <Chip
                                                  label="Cancelled"
                                                  size="small"
                                                  sx={{ bgcolor: "#fee2e2", color: "#b91c1c", fontWeight: 600 }}
                                                />
                                              ) : appt.TreatmentStatus === "C" ? (
                                                <Chip
                                                  label="Completed"
                                                  size="small"
                                                  sx={{ bgcolor: "#dcfce7", color: "#15803d", fontWeight: 600 }}
                                                />
                                              ) : (
                                                <Chip
                                                  label="Pending"
                                                  size="small"
                                                  sx={{ bgcolor: "#fef3c7", color: "#b45309", fontWeight: 600 }}
                                                />
                                              )}
                                            </TableCell>
                                            
                                            <TableCell align="center">
                                              <Box sx={{ display: "flex", gap: 1, justifyContent: "center" }}>
                                                <IconButton
                                                  size="small"
                                                  onClick={() => handleAddRecord(
                                                    appt.MAD_PATIENT_CODE,
                                                    appt.MAD_APPOINMENT_ID,
                                                    appt.MAD_PATIENT_NO
                                                  )}
                                                  disabled={disabled}
                                                  sx={{
                                                    bgcolor: theme.palette.primary.light,
                                                    color: '#fff',
                                                    '&:hover': { bgcolor: theme.palette.primary.main },
                                                    '&.Mui-disabled': { bgcolor: theme.palette.grey[300], color: theme.palette.grey[500] },
                                                  }}
                                                >
                                                  <AddIcon fontSize="small" />
                                                </IconButton>
                                                
                                                <IconButton
                                                  size="small"
                                                  onClick={() => handleCancelAppointment(appt.MAD_APPOINMENT_ID)}
                                                  disabled={disabled}
                                                  sx={{
                                                    bgcolor: "#fee2e2",
                                                    color: "#dc2626",
                                                    '&:hover': { bgcolor: "#dc2626", color: '#fff' },
                                                    '&.Mui-disabled': { bgcolor: theme.palette.grey[300], color: theme.palette.grey[500] },
                                                  }}
                                                >
                                                  <CloseIcon fontSize="small" />
                                                </IconButton>
                                              </Box>
                                            </TableCell>
                                          </TableRow>
                                        );
                                      })}
                                  </TableBody>
                                </Table>
                              </TableContainer>

                              {/* Stats Footer */}
                              {appointments.length > 0 && (
                                <Box
                                  sx={{
                                    mt: 2,
                                    pt: 2,
                                    borderTop: `1px solid ${theme.palette.divider}`,
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    flexWrap: "wrap",
                                    gap: 1,
                                  }}
                                >
                                  <Typography variant="caption" color="text.secondary">
                                    Showing {appointments.filter(a => searchTerm ? a.MAD_FULL_NAME.toLowerCase().includes(searchTerm.toLowerCase()) : true).length} of {appointments.length} appointments
                                  </Typography>
                                  <Box sx={{ display: "flex", gap: 1 }}>
                                    <Chip
                                      size="small"
                                      label={`${stats.pending} Pending`}
                                      sx={{ bgcolor: "#fef3c7", color: "#b45309" }}
                                    />
                                    <Chip
                                      size="small"
                                      label={`${stats.completed} Completed`}
                                      sx={{ bgcolor: "#dcfce7", color: "#15803d" }}
                                    />
                                    {stats.cancelled > 0 && (
                                      <Chip
                                        size="small"
                                        label={`${stats.cancelled} Cancelled`}
                                        sx={{ bgcolor: "#fee2e2", color: "#b91c1c" }}
                                      />
                                    )}
                                  </Box>
                                </Box>
                              )}
                            </>
                          )}
                        </Box>
                      )}
                    </Paper>
                  );
                })}
              </Stack>
            )}
          </CardContent>
        </Card>
      </Paper>

      {/* Snackbar */}
      <Snackbar
        open={snack.open}
        autoHideDuration={5000}
        onClose={() => setSnack((s) => ({ ...s, open: false }))}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={() => setSnack((s) => ({ ...s, open: false }))}
          severity={snack.sev}
          sx={{ width: "100%" }}
        >
          {snack.msg}
        </Alert>
      </Snackbar>
    </Container>
  );
}

// import { useEffect, useState } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import {
//   Box,
//   Button,
//   CircularProgress,
//   IconButton,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TextField,
//   Typography,
//   Chip,
//   useTheme,
//   useMediaQuery,
//   Avatar,
//   Snackbar,
//   Alert,
//   InputAdornment,
//   Tooltip,
//   LinearProgress,
//   Card,
//   CardContent,
//   Grid,
//   Divider,
//   Fade,
//   Zoom,
//   Badge,
//   Stack,
//   alpha,
// } from "@mui/material";
// import {
//   AccessTime as TimeIcon,
//   Add as AddIcon,
//   CheckCircle as CheckCircleIcon,
//   Pending as PendingIcon,
//   Search as SearchIcon,
//   Close as CloseIcon,
//   ChevronLeft as ChevronLeftIcon,
//   ChevronRight as ChevronRightIcon,
//   CalendarMonth as CalendarIcon,
//   EventNote as EventNoteIcon,
//   People as PeopleIcon,
//   Today as TodayIcon,
//   ArrowBack as ArrowBackIcon,
//   PersonOff as PersonOffIcon,
//   HourglassEmpty as HourglassIcon,
//   Phone as PhoneIcon,
//   WatchLater as WatchLaterIcon,
//   DateRange as DateRangeIcon,
//   EventAvailable as EventAvailableIcon,
//   EventBusy as EventBusyIcon,
//   Schedule as ScheduleIcon,
//   MedicalServices as MedicalIcon,
//   KeyboardArrowDown as KeyboardArrowDownIcon,
//   KeyboardArrowUp as KeyboardArrowUpIcon,
//   ExpandMore as ExpandMoreIcon,
//   ExpandLess as ExpandLessIcon,
//   CalendarToday as CalendarTodayIcon,
//   ViewWeek as ViewWeekIcon,
//   ViewModule as ViewModuleIcon,
//   TrendingUp as TrendingUpIcon,
// } from "@mui/icons-material";

// /* ─────────────────────────────────────────────
//    CONSTANTS & HELPERS
// ───────────────────────────────────────────── */
// const BRAND = {
//   main: "#1976d2",
//   dark: "#115293",
//   light: "#42a5f5",
//   bg: "#e3f2fd",
// };

// const toISO = (d) =>
//   `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
//     d.getDate()
//   ).padStart(2, "0")}`;

// const formatTime = (t) =>
//   new Date(`1970-01-01T${t}`).toLocaleTimeString("en-LK", {
//     hour: "numeric",
//     minute: "numeric",
//     hour12: true,
//   });

// const MONTHS = [
//   "January", "February", "March", "April", "May", "June",
//   "July", "August", "September", "October", "November", "December",
// ];

// const getWeekDays = (date) => {
//   const start = new Date(date);
//   start.setDate(date.getDate() - date.getDay());
//   const days = [];
//   for (let i = 0; i < 7; i++) {
//     const day = new Date(start);
//     day.setDate(start.getDate() + i);
//     days.push(day);
//   }
//   return days;
// };

// /* ─────────────────────────────────────────────
//    MAIN COMPONENT
// ───────────────────────────────────────────── */
// export default function DailyAppointment() {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//   const isMd = useMediaQuery(theme.breakpoints.down("md"));

//   const navigate = useNavigate();
//   // const Name = localStorage.getItem("Name") || "Doctor";
//   const Name = "Primali Perera";

//   /* ── state ── */
//   const [viewMode, setViewMode] = useState("week"); // "week" or "month"
//   const [currentDate, setCurrentDate] = useState(new Date());
//   const [selectedDate, setSelectedDate] = useState(toISO(new Date()));
//   const [timeslots, setTimeslots] = useState([]);
//   const [appointments, setAppointments] = useState([]);
//   const [selectedSlot, setSelectedSlot] = useState(null);
//   const [loadingSlots, setLoadingSlots] = useState(false);
//   const [loadingAppts, setLoadingAppts] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [slotStats, setSlotStats] = useState({});
//   const [expandedSlot, setExpandedSlot] = useState(null);
//   const [dateStats, setDateStats] = useState({});
//   const [snack, setSnack] = useState({ open: false, msg: "", sev: "info" });

//   const showSnack = (msg, sev = "info") => setSnack({ open: true, msg, sev });

//   /* ── fetch timeslots ── */
//   useEffect(() => {
//     const run = async () => {
//       setLoadingSlots(true);
//       setTimeslots([]);
//       setAppointments([]);
//       setSelectedSlot(null);
//       setExpandedSlot(null);
//       try {
//         const res = await axios.get(
//           `${process.env.REACT_APP_API_BASE_URL}/Timeslot/timeslotcard/${selectedDate}/${Name}`
//         );
//         setTimeslots(res.data);
        
//         // Fetch appointments for each slot to get stats
//         const stats = {};
//         for (const slot of res.data) {
//           try {
//             const apptRes = await axios.get(
//               `${process.env.REACT_APP_API_BASE_URL}/Appointment/appointments/${slot.MT_SLOT_ID}`
//             );
//             const appts = apptRes.data;
//             stats[slot.MT_SLOT_ID] = {
//               total: appts.length,
//               pending: appts.filter(a => a.MAD_STATUS !== "I" && !a.TreatmentStatus).length,
//               completed: appts.filter(a => a.TreatmentStatus === "C").length,
//               cancelled: appts.filter(a => a.MAD_STATUS === "I").length,
//               appointments: appts,
//             };
//           } catch {
//             stats[slot.MT_SLOT_ID] = { total: 0, pending: 0, completed: 0, cancelled: 0, appointments: [] };
//           }
//         }
//         setSlotStats(stats);
//       } catch {
//         showSnack("No timeslots found for selected date", "info");
//       } finally {
//         setLoadingSlots(false);
//       }
//     };
//     if (selectedDate) run();
//   }, [selectedDate, Name]);

//   /* ── fetch date stats for calendar view ── */
//   useEffect(() => {
//     const fetchDateStats = async () => {
//       const year = currentDate.getFullYear();
//       const month = currentDate.getMonth();
//       const daysInMonth = new Date(year, month + 1, 0).getDate();
//       const stats = {};
      
//       for (let day = 1; day <= daysInMonth; day++) {
//         const dateStr = `${year}-${String(month + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
//         try {
//           const res = await axios.get(
//             `${process.env.REACT_APP_API_BASE_URL}/Timeslot/timeslotcard/${dateStr}/${Name}`
//           );
//           let totalBookings = 0;
//           for (const slot of res.data) {
//             try {
//               const apptRes = await axios.get(
//                 `${process.env.REACT_APP_API_BASE_URL}/Appointment/appointments/${slot.MT_SLOT_ID}`
//               );
//               totalBookings += apptRes.data.length;
//             } catch {
//               // No appointments
//             }
//           }
//           stats[dateStr] = {
//             slots: res.data.length,
//             bookings: totalBookings,
//           };
//         } catch {
//           stats[dateStr] = { slots: 0, bookings: 0 };
//         }
//       }
//       setDateStats(stats);
//     };
    
//     fetchDateStats();
//   }, [currentDate, Name]);

//   /* ── fetch appointments for selected slot ── */
//   const handleViewSlot = async (slot) => {
//     if (expandedSlot === slot.MT_SLOT_ID) {
//       setExpandedSlot(null);
//       setSelectedSlot(null);
//       setAppointments([]);
//       return;
//     }

//     setLoadingAppts(true);
//     setSelectedSlot(slot);
//     setSearchTerm("");
//     try {
//       const res = await axios.get(
//         `${process.env.REACT_APP_API_BASE_URL}/Appointment/appointments/${slot.MT_SLOT_ID}`
//       );
//       setAppointments(res.data);
//       setExpandedSlot(slot.MT_SLOT_ID);
//     } catch {
//       showSnack("No appointments available for this timeslot", "info");
//       setAppointments([]);
//     } finally {
//       setLoadingAppts(false);
//     }
//   };

//   const handleCancelAppointment = async (appointmentId) => {
//     try {
//       await axios.delete(
//         `${process.env.REACT_APP_API_BASE_URL}/Appointment/cancel-appointment/${appointmentId}`
//       );
//       setAppointments((prev) =>
//         prev.map((a) =>
//           a.MAD_APPOINMENT_ID === appointmentId
//             ? { ...a, MAD_STATUS: "I" }
//             : a
//         )
//       );
//       showSnack("Appointment cancelled successfully", "success");
//     } catch {
//       showSnack("Failed to cancel appointment", "error");
//     }
//   };

//   const handleAddRecord = (patientId, appointmentID, patientNo) => {
//     navigate(`/dashboard/addrecord/${patientId}`, {
//       state: {
//         appointmentid: appointmentID,
//         channelnumber: patientNo,
//         MTD_APPOINMENT_ID: appointmentID,
//       },
//     });
//   };

//   /* ── calendar generation ── */
//   const weekDays = getWeekDays(currentDate);
//   const monthDays = [];
//   const year = currentDate.getFullYear();
//   const month = currentDate.getMonth();
//   const daysInMonth = new Date(year, month + 1, 0).getDate();
  
//   for (let i = 1; i <= daysInMonth; i++) {
//     monthDays.push(new Date(year, month, i));
//   }

//   /* ── gradient ── */
//   const grad = `linear-gradient(135deg, ${BRAND.dark} 0%, ${BRAND.main} 55%, ${BRAND.light} 100%)`;

//   /* ── calculate totals for cards ── */
//   const totalSlots = timeslots.length;
//   const totalBookings = Object.values(slotStats).reduce((sum, stat) => sum + stat.total, 0);
//   const totalPending = Object.values(slotStats).reduce((sum, stat) => sum + stat.pending, 0);
//   const totalCompleted = Object.values(slotStats).reduce((sum, stat) => sum + stat.completed, 0);
//   const totalCancelled = Object.values(slotStats).reduce((sum, stat) => sum + stat.cancelled, 0);

//   /* ─────────────────────── RENDER ─────────────────────── */
//   return (
//     <Box
//       sx={{
//         minHeight: "100vh",
//         width: "100%",
//         bgcolor: "#f8fafc",
//       }}
//     >
//       {/* Header */}
//       <Box
//         sx={{
//           background: grad,
//           px: { xs: 2, sm: 3, md: 4 },
//           py: 2.5,
//           borderBottom: `1px solid ${alpha('#fff', 0.1)}`,
//         }}
//       >
//         <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 2 }}>
//           <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//             <Avatar
//               sx={{
//                 width: 48,
//                 height: 48,
//                 bgcolor: alpha('#fff', 0.2),
//                 color: '#fff',
//               }}
//             >
//               <CalendarTodayIcon />
//             </Avatar>
//             <Box>
//               <Typography variant="h5" fontWeight={700} color="white">
//                 Appointment Schedule
//               </Typography>
//               <Typography variant="body2" sx={{ color: alpha('#fff', 0.8) }}>
//                 Dr. {Name} · {MONTHS[currentDate.getMonth()]} {currentDate.getFullYear()}
//               </Typography>
//             </Box>
//           </Box>

//           <Box sx={{ display: "flex", gap: 1 }}>
//             <Button
//               variant={viewMode === "week" ? "contained" : "outlined"}
//               onClick={() => setViewMode("week")}
//               startIcon={<ViewWeekIcon />}
//               sx={{
//                 bgcolor: viewMode === "week" ? '#fff' : 'transparent',
//                 color: viewMode === "week" ? BRAND.main : '#fff',
//                 borderColor: alpha('#fff', 0.3),
//                 '&:hover': {
//                   bgcolor: viewMode === "week" ? '#fff' : alpha('#fff', 0.1),
//                 },
//               }}
//             >
//               Week
//             </Button>
//             <Button
//               variant={viewMode === "month" ? "contained" : "outlined"}
//               onClick={() => setViewMode("month")}
//               startIcon={<ViewModuleIcon />}
//               sx={{
//                 bgcolor: viewMode === "month" ? '#fff' : 'transparent',
//                 color: viewMode === "month" ? BRAND.main : '#fff',
//                 borderColor: alpha('#fff', 0.3),
//                 '&:hover': {
//                   bgcolor: viewMode === "month" ? '#fff' : alpha('#fff', 0.1),
//                 },
//               }}
//             >
//               Month
//             </Button>
//           </Box>
//         </Box>
//       </Box>

//       {/* Main Content */}
//       <Box sx={{ p: { xs: 2, sm: 3 } }}>
//         {/* Summary Cards */}
//         <Grid container spacing={2} sx={{ mb: 3 }}>
//           <Grid item xs={6} sm={3}>
//             <Zoom in={true} style={{ transitionDelay: "100ms" }}>
//               <Card
//                 elevation={0}
//                 sx={{
//                   borderRadius: "16px",
//                   border: `1px solid ${BRAND.bg}`,
//                   background: "#fff",
//                   position: "relative",
//                   overflow: "hidden",
//                   '&:hover': {
//                     boxShadow: `0 8px 24px ${alpha(BRAND.main, 0.15)}`,
//                   },
//                 }}
//               >
//                 <CardContent>
//                   <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//                     <Box
//                       sx={{
//                         width: 48,
//                         height: 48,
//                         borderRadius: "12px",
//                         background: `linear-gradient(135deg, ${BRAND.main}20, ${BRAND.light}10)`,
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                       }}
//                     >
//                       <ScheduleIcon sx={{ color: BRAND.main, fontSize: 28 }} />
//                     </Box>
//                     <Box>
//                       <Typography variant="h4" fontWeight={800} color={BRAND.dark}>
//                         {totalSlots}
//                       </Typography>
//                       <Typography variant="body2" color="text.secondary" fontWeight={500}>
//                         Total Slots
//                       </Typography>
//                     </Box>
//                   </Box>
//                 </CardContent>
//               </Card>
//             </Zoom>
//           </Grid>

//           <Grid item xs={6} sm={3}>
//             <Zoom in={true} style={{ transitionDelay: "200ms" }}>
//               <Card
//                 elevation={0}
//                 sx={{
//                   borderRadius: "16px",
//                   border: `1px solid ${BRAND.bg}`,
//                   background: "#fff",
//                   position: "relative",
//                   overflow: "hidden",
//                   '&:hover': {
//                     boxShadow: `0 8px 24px ${alpha('#f59e0b', 0.15)}`,
//                   },
//                 }}
//               >
//                 <CardContent>
//                   <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//                     <Box
//                       sx={{
//                         width: 48,
//                         height: 48,
//                         borderRadius: "12px",
//                         background: "linear-gradient(135deg, #f59e0b20, #fbbf2410)",
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                       }}
//                     >
//                       <HourglassIcon sx={{ color: "#f59e0b", fontSize: 28 }} />
//                     </Box>
//                     <Box>
//                       <Typography variant="h4" fontWeight={800} color="#f59e0b">
//                         {totalPending}
//                       </Typography>
//                       <Typography variant="body2" color="text.secondary" fontWeight={500}>
//                         Pending
//                       </Typography>
//                     </Box>
//                   </Box>
//                 </CardContent>
//               </Card>
//             </Zoom>
//           </Grid>

//           <Grid item xs={6} sm={3}>
//             <Zoom in={true} style={{ transitionDelay: "300ms" }}>
//               <Card
//                 elevation={0}
//                 sx={{
//                   borderRadius: "16px",
//                   border: `1px solid ${BRAND.bg}`,
//                   background: "#fff",
//                   position: "relative",
//                   overflow: "hidden",
//                   '&:hover': {
//                     boxShadow: `0 8px 24px ${alpha('#16a34a', 0.15)}`,
//                   },
//                 }}
//               >
//                 <CardContent>
//                   <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//                     <Box
//                       sx={{
//                         width: 48,
//                         height: 48,
//                         borderRadius: "12px",
//                         background: "linear-gradient(135deg, #16a34a20, #4ade8010)",
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                       }}
//                     >
//                       <CheckCircleIcon sx={{ color: "#16a34a", fontSize: 28 }} />
//                     </Box>
//                     <Box>
//                       <Typography variant="h4" fontWeight={800} color="#16a34a">
//                         {totalCompleted}
//                       </Typography>
//                       <Typography variant="body2" color="text.secondary" fontWeight={500}>
//                         Completed
//                       </Typography>
//                     </Box>
//                   </Box>
//                 </CardContent>
//               </Card>
//             </Zoom>
//           </Grid>

//           <Grid item xs={6} sm={3}>
//             <Zoom in={true} style={{ transitionDelay: "400ms" }}>
//               <Card
//                 elevation={0}
//                 sx={{
//                   borderRadius: "16px",
//                   border: `1px solid ${BRAND.bg}`,
//                   background: "#fff",
//                   position: "relative",
//                   overflow: "hidden",
//                   '&:hover': {
//                     boxShadow: `0 8px 24px ${alpha('#dc2626', 0.15)}`,
//                   },
//                 }}
//               >
//                 <CardContent>
//                   <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//                     <Box
//                       sx={{
//                         width: 48,
//                         height: 48,
//                         borderRadius: "12px",
//                         background: "linear-gradient(135deg, #dc262620, #ef444410)",
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                       }}
//                     >
//                       <PersonOffIcon sx={{ color: "#dc2626", fontSize: 28 }} />
//                     </Box>
//                     <Box>
//                       <Typography variant="h4" fontWeight={800} color="#dc2626">
//                         {totalCancelled}
//                       </Typography>
//                       <Typography variant="body2" color="text.secondary" fontWeight={500}>
//                         Cancelled
//                       </Typography>
//                     </Box>
//                   </Box>
//                 </CardContent>
//               </Card>
//             </Zoom>
//           </Grid>
//         </Grid>

//         {/* Calendar View */}
//         <Paper
//           elevation={0}
//           sx={{
//             borderRadius: "20px",
//             border: `1px solid ${BRAND.bg}`,
//             overflow: "hidden",
//             mb: 3,
//             bgcolor: "#fff",
//           }}
//         >
//           {/* Calendar Navigation */}
//           <Box
//             sx={{
//               p: 2,
//               borderBottom: `1px solid ${BRAND.bg}`,
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               bgcolor: BRAND.bg,
//             }}
//           >
//             <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//               <IconButton
//                 onClick={() => {
//                   const newDate = new Date(currentDate);
//                   if (viewMode === "week") {
//                     newDate.setDate(currentDate.getDate() - 7);
//                   } else {
//                     newDate.setMonth(currentDate.getMonth() - 1);
//                   }
//                   setCurrentDate(newDate);
//                 }}
//                 sx={{ bgcolor: '#fff', '&:hover': { bgcolor: '#fff' } }}
//               >
//                 <ChevronLeftIcon />
//               </IconButton>
//               <Typography variant="h6" fontWeight={700} color={BRAND.dark}>
//                 {viewMode === "week" 
//                   ? `${weekDays[0].toLocaleDateString()} - ${weekDays[6].toLocaleDateString()}`
//                   : `${MONTHS[currentDate.getMonth()]} ${currentDate.getFullYear()}`
//                 }
//               </Typography>
//               <IconButton
//                 onClick={() => {
//                   const newDate = new Date(currentDate);
//                   if (viewMode === "week") {
//                     newDate.setDate(currentDate.getDate() + 7);
//                   } else {
//                     newDate.setMonth(currentDate.getMonth() + 1);
//                   }
//                   setCurrentDate(newDate);
//                 }}
//                 sx={{ bgcolor: '#fff', '&:hover': { bgcolor: '#fff' } }}
//               >
//                 <ChevronRightIcon />
//               </IconButton>
//             </Box>
//             <Button
//               variant="contained"
//               startIcon={<TodayIcon />}
//               onClick={() => setCurrentDate(new Date())}
//               sx={{
//                 bgcolor: BRAND.main,
//                 '&:hover': { bgcolor: BRAND.dark },
//               }}
//             >
//               Today
//             </Button>
//           </Box>

//           {/* Calendar Grid */}
//           <Box sx={{ p: 2 }}>
//             {viewMode === "week" ? (
//               // Week View - Horizontal Timeline
//               <Box sx={{ display: "flex", gap: 1, overflowX: "auto", pb: 1 }}>
//                 {weekDays.map((day, index) => {
//                   const dateStr = toISO(day);
//                   const isToday = dateStr === toISO(new Date());
//                   const isSelected = dateStr === selectedDate;
//                   const stats = dateStats[dateStr] || { slots: 0, bookings: 0 };
                  
//                   return (
//                     <Card
//                       key={index}
//                       onClick={() => setSelectedDate(dateStr)}
//                       sx={{
//                         minWidth: 140,
//                         cursor: "pointer",
//                         borderRadius: "16px",
//                         border: `2px solid ${isSelected ? BRAND.main : 'transparent'}`,
//                         bgcolor: isToday ? alpha(BRAND.main, 0.05) : '#fff',
//                         transition: "all 0.2s",
//                         '&:hover': {
//                           transform: "translateY(-4px)",
//                           boxShadow: `0 8px 24px ${alpha(BRAND.main, 0.15)}`,
//                         },
//                       }}
//                     >
//                       <CardContent>
//                         <Typography variant="subtitle2" color="text.secondary" gutterBottom>
//                           {day.toLocaleDateString('en-US', { weekday: 'short' })}
//                         </Typography>
//                         <Typography variant="h4" fontWeight={700} color={isSelected ? BRAND.main : BRAND.dark}>
//                           {day.getDate()}
//                         </Typography>
//                         <Typography variant="caption" color="text.secondary" display="block">
//                           {day.toLocaleDateString('en-US', { month: 'short' })}
//                         </Typography>
                        
//                         <Box sx={{ mt: 2, display: "flex", gap: 1, flexWrap: "wrap" }}>
//                           {stats.slots > 0 && (
//                             <Chip
//                               size="small"
//                               label={`${stats.slots} slots`}
//                               sx={{ bgcolor: BRAND.bg, color: BRAND.main, fontSize: '0.65rem' }}
//                             />
//                           )}
//                           {stats.bookings > 0 && (
//                             <Chip
//                               size="small"
//                               label={`${stats.bookings} bookings`}
//                               sx={{ bgcolor: alpha(BRAND.main, 0.1), color: BRAND.main, fontSize: '0.65rem' }}
//                             />
//                           )}
//                         </Box>
//                       </CardContent>
//                     </Card>
//                   );
//                 })}
//               </Box>
//             ) : (
//               // Month View - Calendar Grid
//               <Box>
//                 {/* Weekday headers */}
//                 <Grid container spacing={1} sx={{ mb: 1 }}>
//                   {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day) => (
//                     <Grid item xs key={day}>
//                       <Typography align="center" variant="subtitle2" fontWeight={600} color="text.secondary">
//                         {day}
//                       </Typography>
//                     </Grid>
//                   ))}
//                 </Grid>
                
//                 {/* Calendar days */}
//                 <Grid container spacing={1}>
//                   {Array.from({ length: new Date(year, month, 1).getDay() }).map((_, i) => (
//                     <Grid item xs key={`empty-${i}`}>
//                       <Box sx={{ height: 100 }} />
//                     </Grid>
//                   ))}
                  
//                   {monthDays.map((day) => {
//                     const dateStr = toISO(day);
//                     const isToday = dateStr === toISO(new Date());
//                     const isSelected = dateStr === selectedDate;
//                     const stats = dateStats[dateStr] || { slots: 0, bookings: 0 };
                    
//                     return (
//                       <Grid item xs key={dateStr}>
//                         <Paper
//                           onClick={() => setSelectedDate(dateStr)}
//                           elevation={0}
//                           sx={{
//                             height: 100,
//                             p: 1,
//                             cursor: "pointer",
//                             borderRadius: "12px",
//                             border: `2px solid ${isSelected ? BRAND.main : 'transparent'}`,
//                             bgcolor: isToday ? alpha(BRAND.main, 0.05) : '#fff',
//                             transition: "all 0.2s",
//                             '&:hover': {
//                               bgcolor: alpha(BRAND.main, 0.02),
//                               transform: "scale(0.98)",
//                             },
//                           }}
//                         >
//                           <Typography 
//                             variant="h6" 
//                             fontWeight={isToday ? 700 : 500}
//                             color={isSelected ? BRAND.main : isToday ? BRAND.main : 'text.primary'}
//                           >
//                             {day.getDate()}
//                           </Typography>
                          
//                           {stats.slots > 0 && (
//                             <Box sx={{ mt: 1 }}>
//                               <Chip
//                                 size="small"
//                                 label={`${stats.slots}`}
//                                 sx={{ 
//                                   height: 20, 
//                                   fontSize: '0.6rem',
//                                   bgcolor: BRAND.main,
//                                   color: '#fff',
//                                   fontWeight: 600,
//                                 }}
//                               />
//                             </Box>
//                           )}
                          
//                           {stats.bookings > 0 && (
//                             <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
//                               {stats.bookings} booking{stats.bookings !== 1 ? 's' : ''}
//                             </Typography>
//                           )}
//                         </Paper>
//                       </Grid>
//                     );
//                   })}
//                 </Grid>
//               </Box>
//             )}
//           </Box>
//         </Paper>

//         {/* Selected Date Info Bar */}
//         <Paper
//           elevation={0}
//           sx={{
//             p: 2,
//             mb: 3,
//             borderRadius: "16px",
//             background: grad,
//             color: '#fff',
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             flexWrap: "wrap",
//             gap: 2,
//           }}
//         >
//           <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//             <CalendarTodayIcon />
//             <Box>
//               <Typography variant="h6" fontWeight={700}>
//                 {new Date(selectedDate + "T00:00:00").toLocaleDateString("en-LK", {
//                   weekday: "long",
//                   year: "numeric",
//                   month: "long",
//                   day: "numeric",
//                 })}
//               </Typography>
//               <Typography variant="body2" sx={{ opacity: 0.9 }}>
//                 {totalSlots} timeslot{totalSlots !== 1 ? 's' : ''} available · {totalBookings} total booking{totalBookings !== 1 ? 's' : ''}
//               </Typography>
//             </Box>
//           </Box>
          
//           <Box sx={{ display: "flex", gap: 2 }}>
//             <Chip
//               icon={<HourglassIcon />}
//               label={`${totalPending} Pending`}
//               sx={{ bgcolor: alpha('#fff', 0.2), color: '#fff', fontWeight: 600 }}
//             />
//             <Chip
//               icon={<CheckCircleIcon />}
//               label={`${totalCompleted} Completed`}
//               sx={{ bgcolor: alpha('#fff', 0.2), color: '#fff', fontWeight: 600 }}
//             />
//             {totalCancelled > 0 && (
//               <Chip
//                 icon={<PersonOffIcon />}
//                 label={`${totalCancelled} Cancelled`}
//                 sx={{ bgcolor: alpha('#fff', 0.2), color: '#fff', fontWeight: 600 }}
//               />
//             )}
//           </Box>
//         </Paper>

//         {/* Timeslots Section */}
//         <Paper
//           elevation={0}
//           sx={{
//             borderRadius: "20px",
//             border: `1px solid ${BRAND.bg}`,
//             overflow: "hidden",
//             bgcolor: "#fff",
//           }}
//         >
//           {/* Section Header */}
//           <Box
//             sx={{
//               px: 3,
//               py: 2.5,
//               borderBottom: `1px solid ${BRAND.bg}`,
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               bgcolor: '#fafbfc',
//             }}
//           >
//             <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
//               <EventNoteIcon sx={{ color: BRAND.main }} />
//               <Typography variant="h6" fontWeight={700} color={BRAND.dark}>
//                 Today's Schedule
//               </Typography>
//             </Box>
//             <Typography variant="body2" color="text.secondary">
//               {timeslots.length} timeslot{timeslots.length !== 1 ? 's' : ''} available
//             </Typography>
//           </Box>

//           {/* Timeslots List */}
//           <Box sx={{ p: 3 }}>
//             {loadingSlots ? (
//               <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
//                 <CircularProgress sx={{ color: BRAND.main }} />
//               </Box>
//             ) : timeslots.length === 0 ? (
//               <Box
//                 sx={{
//                   textAlign: "center",
//                   py: 8,
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "center",
//                   gap: 2,
//                 }}
//               >
//                 <EventBusyIcon sx={{ fontSize: 64, color: `${BRAND.main}30` }} />
//                 <Typography variant="h6" sx={{ color: "#64748b" }}>
//                   No Timeslots Available
//                 </Typography>
//                 <Typography variant="body2" sx={{ color: "#94a3b8" }}>
//                   Select a different date from the calendar
//                 </Typography>
//               </Box>
//             ) : (
//               <Stack spacing={2}>
//                 {timeslots.map((slot) => {
//                   const stats = slotStats[slot.MT_SLOT_ID] || { total: 0, pending: 0, completed: 0, cancelled: 0 };
//                   const isExpanded = expandedSlot === slot.MT_SLOT_ID;
                  
//                   return (
//                     <Paper
//                       key={slot.MT_SLOT_ID}
//                       elevation={0}
//                       sx={{
//                         border: `1px solid ${isExpanded ? BRAND.main : BRAND.bg}`,
//                         borderRadius: "16px",
//                         overflow: "hidden",
//                         transition: "all 0.3s ease",
//                         bgcolor: '#fff',
//                       }}
//                     >
//                       {/* Slot Header */}
//                       <Box
//                         onClick={() => handleViewSlot(slot)}
//                         sx={{
//                           p: 2.5,
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 2,
//                           cursor: "pointer",
//                           bgcolor: isExpanded ? alpha(BRAND.main, 0.02) : '#fff',
//                           '&:hover': {
//                             bgcolor: alpha(BRAND.main, 0.02),
//                           },
//                         }}
//                       >
//                         <Avatar
//                           sx={{
//                             width: 56,
//                             height: 56,
//                             bgcolor: isExpanded ? BRAND.main : BRAND.bg,
//                             color: isExpanded ? '#fff' : BRAND.main,
//                             fontWeight: 800,
//                           }}
//                         >
//                           {slot.MT_DOCTOR?.charAt(0).toUpperCase()}
//                         </Avatar>

//                         <Box sx={{ flex: 1 }}>
//                           <Typography variant="h6" fontWeight={700} color="#1e293b">
//                             {slot.MT_DOCTOR}
//                           </Typography>
//                           <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "wrap", mt: 0.5 }}>
//                             <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
//                               <TimeIcon sx={{ fontSize: 16, color: BRAND.main }} />
//                               <Typography variant="body2" color="text.secondary">
//                                 {formatTime(slot.MT_START_TIME)} - {formatTime(slot.MT_END_TIME)}
//                               </Typography>
//                             </Box>
                            
//                             <Box sx={{ display: "flex", gap: 1 }}>
//                               {stats.pending > 0 && (
//                                 <Chip
//                                   size="small"
//                                   label={`${stats.pending} Pending`}
//                                   sx={{ bgcolor: "#fef3c7", color: "#b45309", fontWeight: 600 }}
//                                 />
//                               )}
//                               {stats.completed > 0 && (
//                                 <Chip
//                                   size="small"
//                                   label={`${stats.completed} Completed`}
//                                   sx={{ bgcolor: "#dcfce7", color: "#15803d", fontWeight: 600 }}
//                                 />
//                               )}
//                             </Box>
//                           </Box>
//                         </Box>

//                         <Box
//                           sx={{
//                             px: 2,
//                             py: 1,
//                             borderRadius: "8px",
//                             bgcolor: isExpanded ? BRAND.main : BRAND.bg,
//                             color: isExpanded ? '#fff' : BRAND.main,
//                             fontWeight: 700,
//                             display: "flex",
//                             alignItems: "center",
//                             gap: 0.5,
//                           }}
//                         >
//                           <PeopleIcon sx={{ fontSize: 18 }} />
//                           <Typography variant="body2" fontWeight={700}>
//                             {stats.total}
//                           </Typography>
//                           {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
//                         </Box>
//                       </Box>

//                       {/* Expanded Appointments */}
//                       {isExpanded && (
//                         <Fade in={true}>
//                           <Box sx={{ borderTop: `1px solid ${BRAND.bg}`, p: 2.5, bgcolor: "#fafbfc" }}>
//                             {loadingAppts ? (
//                               <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
//                                 <CircularProgress size={32} sx={{ color: BRAND.main }} />
//                               </Box>
//                             ) : appointments.length === 0 ? (
//                               <Box sx={{ textAlign: "center", py: 4 }}>
//                                 <EventAvailableIcon sx={{ fontSize: 48, color: `${BRAND.main}30`, mb: 1 }} />
//                                 <Typography color="text.secondary">No appointments in this slot</Typography>
//                               </Box>
//                             ) : (
//                               <>
//                                 {/* Search */}
//                                 <TextField
//                                   size="small"
//                                   fullWidth
//                                   placeholder="Search patients..."
//                                   value={searchTerm}
//                                   onChange={(e) => setSearchTerm(e.target.value)}
//                                   sx={{ mb: 2.5 }}
//                                   InputProps={{
//                                     startAdornment: (
//                                       <InputAdornment position="start">
//                                         <SearchIcon sx={{ color: BRAND.main }} />
//                                       </InputAdornment>
//                                     ),
//                                   }}
//                                 />

//                                 {/* Appointments Table */}
//                                 <TableContainer>
//                                   <Table size={isMobile ? "small" : "medium"}>
//                                     <TableHead>
//                                       <TableRow sx={{ bgcolor: BRAND.bg }}>
//                                         <TableCell sx={{ fontWeight: 700, color: BRAND.main }}>Patient</TableCell>
//                                         {!isMobile && <TableCell sx={{ fontWeight: 700, color: BRAND.main }}>Contact</TableCell>}
//                                         <TableCell sx={{ fontWeight: 700, color: BRAND.main }}>Time</TableCell>
//                                         <TableCell sx={{ fontWeight: 700, color: BRAND.main }}>No.</TableCell>
//                                         <TableCell sx={{ fontWeight: 700, color: BRAND.main }}>Status</TableCell>
//                                         <TableCell align="center" sx={{ fontWeight: 700, color: BRAND.main }}>Actions</TableCell>
//                                       </TableRow>
//                                     </TableHead>
//                                     <TableBody>
//                                       {appointments
//                                         .filter(a => 
//                                           searchTerm ? 
//                                           a.MAD_FULL_NAME.toLowerCase().includes(searchTerm.toLowerCase()) : 
//                                           true
//                                         )
//                                         .map((appt) => {
//                                           const isCancelled = appt.MAD_STATUS === "I";
//                                           const isCompleted = appt.TreatmentStatus === "C";
//                                           const disabled = isCancelled || isCompleted;

//                                           return (
//                                             <TableRow
//                                               key={appt.MAD_APPOINMENT_ID}
//                                               sx={{
//                                                 opacity: isCancelled ? 0.65 : 1,
//                                                 bgcolor: isCancelled ? "#fff5f5" : "inherit",
//                                               }}
//                                             >
//                                               <TableCell>
//                                                 <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                                                   <Avatar
//                                                     sx={{
//                                                       width: 32,
//                                                       height: 32,
//                                                       bgcolor: isCancelled ? "#fee2e2" : BRAND.bg,
//                                                       color: isCancelled ? "#dc2626" : BRAND.main,
//                                                       fontSize: 14,
//                                                     }}
//                                                   >
//                                                     {appt.MAD_FULL_NAME.charAt(0)}
//                                                   </Avatar>
//                                                   <Typography variant="body2" fontWeight={600}>
//                                                     {appt.MAD_FULL_NAME}
//                                                   </Typography>
//                                                 </Box>
//                                               </TableCell>
                                              
//                                               {!isMobile && (
//                                                 <TableCell>
//                                                   <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
//                                                     <PhoneIcon sx={{ fontSize: 14, color: BRAND.main }} />
//                                                     <Typography variant="body2">{appt.MAD_CONTACT}</Typography>
//                                                   </Box>
//                                                 </TableCell>
//                                               )}
                                              
//                                               <TableCell>
//                                                 <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
//                                                   <WatchLaterIcon sx={{ fontSize: 14, color: BRAND.main }} />
//                                                   <Typography variant="body2">
//                                                     {formatTime(appt.MAD_ALLOCATED_TIME)}
//                                                   </Typography>
//                                                 </Box>
//                                               </TableCell>
                                              
//                                               <TableCell>
//                                                 <Box
//                                                   sx={{
//                                                     display: "inline-block",
//                                                     px: 1.5,
//                                                     py: 0.3,
//                                                     borderRadius: "6px",
//                                                     border: `1px solid ${BRAND.main}`,
//                                                     color: BRAND.main,
//                                                     fontWeight: 700,
//                                                     fontSize: "0.75rem",
//                                                   }}
//                                                 >
//                                                   {appt.MAD_PATIENT_NO}
//                                                 </Box>
//                                               </TableCell>
                                              
//                                               <TableCell>
//                                                 {appt.MAD_STATUS === "I" ? (
//                                                   <Chip
//                                                     label="Cancelled"
//                                                     size="small"
//                                                     sx={{ bgcolor: "#fee2e2", color: "#b91c1c", fontWeight: 600 }}
//                                                   />
//                                                 ) : appt.TreatmentStatus === "C" ? (
//                                                   <Chip
//                                                     label="Completed"
//                                                     size="small"
//                                                     sx={{ bgcolor: "#dcfce7", color: "#15803d", fontWeight: 600 }}
//                                                   />
//                                                 ) : (
//                                                   <Chip
//                                                     label="Pending"
//                                                     size="small"
//                                                     sx={{ bgcolor: "#fef3c7", color: "#b45309", fontWeight: 600 }}
//                                                   />
//                                                 )}
//                                               </TableCell>
                                              
//                                               <TableCell align="center">
//                                                 <Box sx={{ display: "flex", gap: 1, justifyContent: "center" }}>
//                                                   <Tooltip title={disabled ? "Cannot add treatment" : "Add Treatment"}>
//                                                     <span>
//                                                       <IconButton
//                                                         size="small"
//                                                         onClick={() => handleAddRecord(
//                                                           appt.MAD_PATIENT_CODE,
//                                                           appt.MAD_APPOINMENT_ID,
//                                                           appt.MAD_PATIENT_NO
//                                                         )}
//                                                         disabled={disabled}
//                                                         sx={{
//                                                           bgcolor: BRAND.bg,
//                                                           color: BRAND.main,
//                                                           '&:hover': { bgcolor: BRAND.main, color: '#fff' },
//                                                           '&.Mui-disabled': { bgcolor: '#e2e8f0', color: '#94a3b8' },
//                                                         }}
//                                                       >
//                                                         <AddIcon fontSize="small" />
//                                                       </IconButton>
//                                                     </span>
//                                                   </Tooltip>
                                                  
//                                                   <Tooltip title={disabled ? "Cannot cancel" : "Cancel"}>
//                                                     <span>
//                                                       <IconButton
//                                                         size="small"
//                                                         onClick={() => handleCancelAppointment(appt.MAD_APPOINMENT_ID)}
//                                                         disabled={disabled}
//                                                         sx={{
//                                                           bgcolor: "#fee2e2",
//                                                           color: "#dc2626",
//                                                           '&:hover': { bgcolor: "#dc2626", color: '#fff' },
//                                                           '&.Mui-disabled': { bgcolor: '#e2e8f0', color: '#94a3b8' },
//                                                         }}
//                                                       >
//                                                         <CloseIcon fontSize="small" />
//                                                       </IconButton>
//                                                     </span>
//                                                   </Tooltip>
//                                                 </Box>
//                                               </TableCell>
//                                             </TableRow>
//                                           );
//                                         })}
//                                     </TableBody>
//                                   </Table>
//                                 </TableContainer>

//                                 {/* Stats Footer */}
//                                 {appointments.length > 0 && (
//                                   <Box
//                                     sx={{
//                                       mt: 2,
//                                       pt: 2,
//                                       borderTop: `1px solid ${BRAND.bg}`,
//                                       display: "flex",
//                                       justifyContent: "space-between",
//                                       alignItems: "center",
//                                     }}
//                                   >
//                                     <Typography variant="caption" color="text.secondary">
//                                       Showing {appointments.filter(a => searchTerm ? a.MAD_FULL_NAME.toLowerCase().includes(searchTerm.toLowerCase()) : true).length} of {appointments.length} appointments
//                                     </Typography>
//                                     <Box sx={{ display: "flex", gap: 1 }}>
//                                       <Chip
//                                         size="small"
//                                         label={`${stats.pending} Pending`}
//                                         sx={{ bgcolor: "#fef3c7", color: "#b45309" }}
//                                       />
//                                       <Chip
//                                         size="small"
//                                         label={`${stats.completed} Completed`}
//                                         sx={{ bgcolor: "#dcfce7", color: "#15803d" }}
//                                       />
//                                       {stats.cancelled > 0 && (
//                                         <Chip
//                                           size="small"
//                                           label={`${stats.cancelled} Cancelled`}
//                                           sx={{ bgcolor: "#fee2e2", color: "#b91c1c" }}
//                                         />
//                                       )}
//                                     </Box>
//                                   </Box>
//                                 )}
//                               </>
//                             )}
//                           </Box>
//                         </Fade>
//                       )}
//                     </Paper>
//                   );
//                 })}
//               </Stack>
//             )}
//           </Box>
//         </Paper>
//       </Box>

//       {/* Snackbar */}
//       <Snackbar
//         open={snack.open}
//         autoHideDuration={5000}
//         onClose={() => setSnack((s) => ({ ...s, open: false }))}
//         anchorOrigin={{ vertical: "top", horizontal: "right" }}
//       >
//         <Alert
//           onClose={() => setSnack((s) => ({ ...s, open: false }))}
//           severity={snack.sev}
//           sx={{ width: "100%" }}
//         >
//           {snack.msg}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// }